webpackJsonp([1],{

/***/ "+333":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('fr');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Account',
  data: function data() {
    return {
      account: {}
    };
  },

  methods: {
    buttonTypeMenu: function buttonTypeMenu(status) {
      this.$router.push(status);
    },
    logout: function logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('login');
      localStorage.removeItem('password');
      this.$router.push('/');
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("/1Lr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+zgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Interventions_vue__ = __webpack_require__("NBMU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d334d92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Interventions_vue__ = __webpack_require__("eGWh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Interventions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d334d92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Interventions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/1Lr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1nLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEw8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CRM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CYrB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CuRo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dqkq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  methods: {
    buttonTypeMenu: function buttonTypeMenu(status) {
      this.$router.push(status);
    }
  }
});

/***/ }),

/***/ "FzH4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G1de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.data).length)?_c('div',_vm._l((_vm.data),function(question,questionKey){return _c('div',{key:questionKey,staticClass:"content debrief sub"},[_c('div',{staticClass:"condition hide"},[_vm._v(_vm._s(JSON.stringify(question.condition)))]),_vm._v(" "),_c('div',{staticClass:"question",attrs:{"data-required":question.required,"data-question-id":question.question_id}},[_c('div',{staticClass:"label"},[_vm._v("\n        "+_vm._s(question.question_label)+"\n        "),(question.required)?_c('div',{staticClass:"required"},[_vm._v("( Réponse obligatoire )")]):_vm._e()]),_vm._v(" "),_vm._l((question.reponse),function(response,responseKey){return _c('div',{key:responseKey},[_c('div',{staticClass:"reponse-button action",class:{ check: _vm.isChecked(question.question_id, response.reponse_id) },attrs:{"data-question-id":question.question_id,"data-reponse-id":response.reponse_id},on:{"click":function($event){_vm.handleResponseClick(question.question_id, response.reponse_id)}}},[_c('i',{staticClass:"fa fa-check",class:{ hide: !_vm.isChecked(question.question_id, response.reponse_id) },attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(response.reponse_label)+"\n        ")])])}),_vm._v(" "),(question.custom_response)?_c('div',{staticClass:"reponse-input",attrs:{"data-question-id":question.question_id}},[_c('input',{attrs:{"type":"text","placeholder":"Votre réponse"}})]):_vm._e()],2)])})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gh6p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("PKAF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I6Hl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"authenticated"},[_c('b-navbar',{attrs:{"toggleable":"md","fixed":"top","type":"dark","variant":"info"}},[_c('b-navbar-brand',{on:{"click":function($event){_vm.buttonTypeMenu('/accueil')}}},[_vm._v("AboRacco "),_c('div',{staticClass:"version"},[_vm._v("2026.42.1")])]),_vm._v(" "),_c('b-nav-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/interventions/prod/open"}},[_vm._v("Production")]),_vm._v(" "),_c('router-link',{staticClass:"nav-link",attrs:{"to":"/interventions/postprodsav/open"}},[_vm._v("Post-Production / SAV")]),_vm._v(" "),_c('router-link',{staticClass:"nav-link",attrs:{"to":"/interventions/audit/open"}},[_vm._v("Audit")]),_vm._v(" "),_c('router-link',{staticClass:"nav-link",attrs:{"to":"/testarbre"}},[_vm._v("Test des arbres")]),_vm._v(" "),_c('router-link',{staticClass:"nav-link",attrs:{"to":"/account"}},[_vm._v("Mon compte")])],1)],1)],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("rrPM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("nHb0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JmD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debrief_vue__ = __webpack_require__("yJkR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2606a980_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debrief_vue__ = __webpack_require__("l4aH");
function injectStyle (ssrContext) {
  __webpack_require__("Dqkq")
  __webpack_require__("e7Rj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2606a980"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debrief_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2606a980_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debrief_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KMPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interventions"},[_c('div',{staticClass:"header-intervention"},[_c('div',{staticClass:"intervention-type"},[_vm._v("\n     Scan de l'ONU\n    ")]),_vm._v(" "),_c('b-button-group',{staticClass:"group",attrs:{"size":"sm"}},[_c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":function($event){_vm.StartScan()}}},[_vm._v("Auto")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":function($event){_vm.CloseScan()}}},[_vm._v("Manuelle")])],1)],1),_vm._v(" "),_c('b-container',{staticClass:"account-content"},[_c('div',{staticClass:"viewport hide",attrs:{"id":"interactive"}},[_c('video',{staticClass:"video",attrs:{"autoplay":"true","preload":"auto","src":""}})]),_vm._v(" "),_c('div',{staticClass:"manuel",attrs:{"id":"manuelle"}},[_c('div',{staticClass:"label"},[_c('b',[_vm._v("Saisie manuelle : ")]),_c('input',{staticClass:"header-info",attrs:{"id":"scanne_manuel","placeholder":"Scan du ONU","type":"text"}}),_vm._v(" "),_c('b-button',{staticClass:"button",attrs:{"variant":"outline-default"},on:{"click":function($event){_vm.envoiScan()}}},[_vm._v("Saisie manuelle")])],1)]),_vm._v(" "),_c('div',{staticClass:"manuel",attrs:{"id":"result","hide":""}},[_c('div',{staticClass:"label"},[_c('b',[_vm._v("Scan recuperer : ")]),_c('input',{staticClass:"header-info",attrs:{"id":"scanner_input","placeholder":"Scan du ONU","type":"text"}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/builds/app/aboracco-portal-v1"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/builds/app/aboracco-portal-v1","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ "LJZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authentification"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-login"},[(!_vm.message)?_c('div',{staticClass:"message"},[_vm._v("Authentification")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[(_vm.message)?_c('div',{staticClass:"message red"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Identifiant CAS"},model:{value:(_vm.User.login),callback:function ($$v) {_vm.$set(_vm.User, "login", $$v)},expression:"User.login"}}),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","placeholder":"Mot de passe"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.User.password),callback:function ($$v) {_vm.$set(_vm.User, "password", $$v)},expression:"User.password"}}),_vm._v(" "),_c('b-button',{staticClass:"btn-login",attrs:{"disabled":_vm.disabled === 1,"variant":"outline-danger"},on:{"click":_vm.login}},[_vm._v("Connexion")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-name-content"},[_c('div',{staticClass:"app-name"},[_vm._v("\n      AboRacco\n    ")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("dft9"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-description"},[_vm._v("\n      Version mobile (2026.42.1)\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e0c6c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("1nLh");
function injectStyle (ssrContext) {
  __webpack_require__("Gh6p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e0c6c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mh7V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MmZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArbreRecursive_vue__ = __webpack_require__("tCYN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89a7696a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArbreRecursive_vue__ = __webpack_require__("G1de");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArbreRecursive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89a7696a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArbreRecursive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NBMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_pulltorefresh__ = __webpack_require__("nqTU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Interventions',
  data: function data() {
    return {
      open: true,
      close: false,
      status: 'open',
      type: null,
      cache: false,
      interventions: [],
      loading: false
    };
  },

  methods: {
    isNotEmpty: function isNotEmpty(interventions) {
      if (interventions === null) {
        return 0;
      }

      return interventions.length === 0 ? 0 : 1;
    },
    buttonTypeIntervention: function buttonTypeIntervention(status) {
      if (status === 'open') {
        this.open = true;
        this.close = false;
      } else {
        this.open = false;
        this.close = true;
      }
      this.status = status;
      this.interventions = [];
      this.$router.push('/interventions/' + this.type + '/' + status);
    },
    getInterventionsList: function getInterventionsList(cb) {
      var _this2 = this;

      this.loading = true;
      this.$http.get('interventions/' + this.type + '/' + this.status).then(function (response) {
        _this2.response = response.json().then(function (data) {
          _this2.interventions = data;
          _this2.interventions.map(function (intervention) {
            if (intervention.typeId === 15 || intervention.typeId === 16) {
              intervention.auditinfra = true;
            } else {
              intervention.auditinfra = false;
            }
          });
          _this2.cache = false;
          _this2.$setItem(_this2.type + '_' + _this2.status, data, function (err, values) {
            if (err) {
              alert(err);
            }
          });

          if (typeof cb === 'function') {
            cb();
          }

          _this2.loading = false;
        });
      }, function (response) {
        if (typeof cb === 'function') {
          cb();
        }
        if (!_this2.cache) {
          _this2.loading = false;
          _this2.$toast.bottom('Une erreur est survenue lors de la récupération des interventions');
        }
      });
    },
    getTypeLabel: function getTypeLabel() {
      if (this.type === 'postprodsav') {
        return 'PostProduction / SAV';
      } else if (this.type === 'prod') {
        return 'Production';
      } else {
        return 'Audit';
      }
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm');
    },
    progressBar: function progressBar(intervention, key) {
      var data = [];
      var a = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date());
      var b = __WEBPACK_IMPORTED_MODULE_0_moment___default()(intervention.dateRdv).add(2, 'hours');
      var diff = b.diff(a);
      var duration = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(diff);
      data.animated = false;

      if (this.close) {
        var _a = __WEBPACK_IMPORTED_MODULE_0_moment___default()(intervention.dateDebut);
        var _b = __WEBPACK_IMPORTED_MODULE_0_moment___default()(intervention.dateFin);
        var _diff = _b.diff(_a);
        var _duration = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(_diff);
        var label = null;

        if (_duration.days() !== 0) {
          label = 'Durée : ' + _duration.days() + 'j ' + _duration.hours() + 'h ' + _duration.minutes() + 'm ' + _duration.seconds() + 's';
        } else {
          label = 'Durée : ' + _duration.hours() + 'h ' + _duration.minutes() + 'm ' + _duration.seconds() + 's';
        }

        data.percent = 100;
        data.className = 'success';
        data.value = label;
        // data.animated = false
        return data[key];
      }

      // Calcul
      if (diff < 0) {
        data.percent = 100;
        data.className = 'danger';
        data.value = 'Intervention en retard';
      } else {
        if (duration.asHours() <= 1.5 && duration.asDays() < 1) {
          data.percent = duration.asHours() / 1.5 * 100;
          data.value = Math.round(duration.asMinutes(), 0) + ' Minutes';
          if (data.percent >= 0 && data.percent <= 30) {
            data.className = 'danger';
          }
          if (data.percent >= 30 && data.percent <= 60) {
            data.className = 'warning';
          }
        } else {
          data.className = 'success';
          data.percent = 100;
          data.value = 'dans ' + duration.days() + ' j ' + duration.hours() + ' h  ' + duration.minutes() + ' m';
        }
      }
      if (intervention.dateDebut !== '0000-00-00 00:00:00') {
        var _a2 = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date());
        var _b2 = __WEBPACK_IMPORTED_MODULE_0_moment___default()(intervention.dateDebut);
        var _diff2 = _a2.diff(_b2);
        var _duration2 = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(_diff2);
        var _label = null;

        if (_duration2.days() !== 0) {
          _label = 'En cours depuis ' + _duration2.days() + 'j ' + _duration2.hours() + 'h ' + _duration2.minutes() + 'm ' + _duration2.seconds() + 's';
        } else {
          _label = 'En cours depuis ' + _duration2.hours() + 'h ' + _duration2.minutes() + 'm ' + _duration2.seconds() + 's';
        }

        data.percent = 100;
        data.className = 'primary';
        data.value = _label;
      }
      return data[key];
    },
    goToIntervention: function goToIntervention(interventionId) {
      this.$router.push('/intervention/' + interventionId);
    },
    getCache: function getCache(context, value) {
      this.$getItem(value, function (err, values) {
        if (err) {
          this.getInterventionsList();
          return;
        }
        if (values === null) {
          context.getInterventionsList();
          return;
        }
        context.cache = true;
        context.interventions = values;
      });
    },
    buttonURL: function buttonURL(status) {
      if (status === 'open') {
        this.open = true;
        this.close = false;
      } else {
        this.open = false;
        this.close = true;
      }
      this.status = status;
    },
    sync: function sync() {
      this.getInterventionsList();
    }
  },
  computed: {
    btnStates: function btnStates() {
      return this.buttons.map(function (btn) {
        return btn.state;
      });
    }
  },
  mounted: function mounted() {
    this.type = this.$route.params.type;
    this.status = this.$route.params.status;
    this.buttonURL(this.status);

    var _this = this;
    __WEBPACK_IMPORTED_MODULE_1__assets_js_pulltorefresh__["a" /* default */].init({
      mainElement: '.interventions-list',
      onRefresh: function onRefresh(cb) {
        _this.getInterventionsList(cb);
      }
    });
    this.getCache(this, this.type + '_' + this.status);
  },
  watch: {
    '$route.params.status': function $routeParamsStatus(newId, oldId) {
      this.status = this.$route.params.status;
      this.type = this.$route.params.type;
      this.buttonURL(this.status);
      this.getCache(this, this.type + '_' + this.status);
    },
    '$route.params.type': function $routeParamsType(newId, oldId) {
      this.status = this.$route.params.status;
      this.type = this.$route.params.type;
      this.buttonURL(this.status);
      this.getCache(this, this.type + '_' + this.status);
    }
  }

});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_localforage__ = __webpack_require__("McBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jsonwebtoken__ = __webpack_require__("abWm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_toast_lib_toast_css__ = __webpack_require__("e195");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_toast_lib_toast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_toast_lib_toast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_toast__ = __webpack_require__("1BT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_latlon_geohash__ = __webpack_require__("Njgl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_latlon_geohash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_latlon_geohash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_css_main_css__ = __webpack_require__("CuRo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_js_modal__);




















window.jquery = __WEBPACK_IMPORTED_MODULE_15_jquery___default.a;
window.$ = __WEBPACK_IMPORTED_MODULE_15_jquery___default.a;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
/* eslint-disable no-new */

var originalVueComponent = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component = function (name, definition) {
  if (name === 'bFormCheckboxGroup' || name === 'bCheckboxGroup' || name === 'bCheckGroup' || name === 'bFormRadioGroup') {
    definition.components = { bFormCheckbox: definition.components[0] };
  }
  originalVueComponent.apply(this, [name, definition]);
};
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue2_toast___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_localforage___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component = originalVueComponent;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['Content-Type'] = 'application/json';

// prod
// Vue.http.options.root = 'https://api.ftth.iliad.fr/app/aboracco/v1'
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.options.root = 'https://api.ftth.iliad.fr/app/aboracco/v1';
function getPos(callback) {
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(navigator.geolocation).length !== 0) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var geohash = __WEBPACK_IMPORTED_MODULE_16_latlon_geohash___default.a.encode(position.coords.latitude, position.coords.longitude);
      callback(__WEBPACK_IMPORTED_MODULE_16_latlon_geohash___default.a.decode(geohash));
    }, function (err) {
      var geohash = null;
      switch (err.code) {
        case err.PERMISSION_DENIED:
          geohash = { 1: 'User bloque la geolocalisation' };
          break;
        case err.POSITION_UNAVAILABLE:
          geohash = { 2: 'Localisation introuvable' };
          break;
        case err.TIMEOUT:
          geohash = { 3: 'Localisation trop long' };
          break;
        case err.UNKNOWN_ERROR:
          geohash = { 4: 'Erreur interne' };
          break;
      }
      callback(geohash);
    });
  } else {
    var geohash = 'Géolocation avec ce navigateur';
    callback(geohash);
  }
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  if (!navigator.onLine) {
    next(request.respondWith(null, {
      status: 404,
      statusText: ''
    }));
    return;
  }

  var _this = this;
  getPos(function (geo) {
    request.headers.set('location', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(geo));
    if (localStorage.getItem('token') !== null) {
      var decoded = __WEBPACK_IMPORTED_MODULE_9_jsonwebtoken___default.a.decode(localStorage.getItem('token'));
      var unix = Math.round(+new Date() / 1000);

      if (decoded.exp <= unix) {
        _this.$router.push('/');
        _this.$toast.bottom('Votre session a expiré');
      } else {
        request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
        next();
      }
    } else {
      next();
    }
  });
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "OCiJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authentification_vue__ = __webpack_require__("QTf3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3192b452_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authentification_vue__ = __webpack_require__("LJZf");
function injectStyle (ssrContext) {
  __webpack_require__("VUkn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authentification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3192b452_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authentification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PKAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PuG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArbreRecursive_vue__ = __webpack_require__("MmZU");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ArbreRecursive: __WEBPACK_IMPORTED_MODULE_3__ArbreRecursive_vue__["a" /* default */] },
  data: function data() {
    return {
      intervention_id: null,
      intervention: {},
      upload: false,
      message: '',
      waiting: {
        position: 0,
        total: 0
      },
      photoBefore: false,
      start: false,
      finalized: false,
      confirmReponses: false,
      photoAfter: false,
      index: 0,
      debrief: [],
      positionsWithTech: [],
      positionsWithoutTech: [],
      requiredResponses: [],
      selectedPositions: []
    };
  },

  watch: {
    requiredResponses: {
      handler: function handler(newVal) {
        this.handleFormValidationChange(this.isFormValid);
      },

      deep: true
    },
    'intervention.pm': {
      handler: function handler(newVal) {
        this.updatePositions();
      }
    }
  },
  computed: {
    showNextButton: function showNextButton() {
      if (this.index < this.positionsWithTech.length - 1) return true;

      var lastIndexSelected = this.intervention.pm.reduce(function (acc, pm, idx) {
        return pm.selected || pm.complete ? idx : acc;
      }, -1);

      return this.index < lastIndexSelected;
    },
    isFormValid: function isFormValid() {
      return this.requiredResponses.every(function (e) {
        return e.answered === true;
      });
    },
    isCurrentPositionWithoutTech: function isCurrentPositionWithoutTech() {
      var _this2 = this;

      return this.positionsWithoutTech.some(function (e) {
        return e.index === _this2.index;
      });
    },
    modalWidth: function modalWidth() {
      if (window.innerWidth < 768) {
        return '90%';
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        return '70%';
      } else {
        return '50%';
      }
    }
  },
  methods: {
    handleFormValidationChange: function handleFormValidationChange(isValid) {
      if (isValid) {
        this.intervention.pm[this.index]['complete'] = true;
      }
    },
    closingModal: function closingModal() {
      this.$modal.hide('new-positions');
    },
    showNewPositions: function showNewPositions() {
      this.$modal.show('new-positions');
    },
    cancelNewPosition: function cancelNewPosition() {
      this.intervention.pm[this.index].reponses = [];
      this.intervention.pm[this.index]['complete'] = false;
      this.intervention.pm[this.index]['selected'] = false;
      this.previousPosition();
    },
    isChecked: function isChecked(questionId, responseId) {
      if (!this.intervention.pm || !this.intervention.pm[this.index] || !this.intervention.pm[this.index].reponses) {
        return false;
      }
      return this.intervention.pm[this.index].reponses.some(function (r) {
        return parseInt(r.question_id) === questionId && parseInt(r.reponse_id) === responseId;
      });
    },
    handleResponseClick: function handleResponseClick(questionId, responseId) {
      var _this3 = this;

      var responses = this.intervention.pm[this.index].reponses;

      var existingResponseIndex = responses.findIndex(function (r) {
        return parseInt(r.question_id) === questionId;
      });
      if (existingResponseIndex !== -1) {
        this.resetDependantValues(questionId);

        this.$delete(responses, existingResponseIndex);
      }
      this.$set(responses, responses.length, { question_id: questionId, reponse_id: responseId });

      var requiredResponseIndex = this.requiredResponses.findIndex(function (r) {
        return r.index === questionId;
      });
      if (requiredResponseIndex !== -1) {
        this.$set(this.requiredResponses, requiredResponseIndex, { index: questionId, answered: true });

        var response = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.debrief).find(function (r) {
          return r.question_id === questionId;
        }).reponse;
        var nextQuestion = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(response).find(function (r) {
          return r.reponse_id === responseId;
        }).next_question;

        if (nextQuestion) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.debrief).forEach(function (question) {
            if (question.required) {
              _this3.$set(_this3.requiredResponses, requiredResponseIndex, { index: questionId, answered: false });
            }
          });
        }
      }

      this.$forceUpdate();
    },
    resetDependantValues: function resetDependantValues(parentQuestion) {
      var _this4 = this;

      var questions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.debrief).find(function (r) {
        return r.question_id === parentQuestion;
      }).reponse;
      var responses = this.intervention.pm[this.index].reponses;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(questions).forEach(function (r) {
        if (r.next_question) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(r.next_question).forEach(function (nexQuestion) {
            var responseIndex = responses.findIndex(function (r) {
              return parseInt(r.question_id) === nexQuestion.question_id;
            });

            if (responseIndex !== -1) {
              _this4.$delete(responses, responseIndex);
            }
          });
        }
      });
    },
    setRequiredResponses: function setRequiredResponses(currentResponses) {
      var responses = [];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.debrief).forEach(function (question) {
        if (question.required) {
          var answered = currentResponses.some(function (response) {
            return parseInt(response.question_id) === question.question_id;
          });
          responses.push({ index: question.question_id, answered: answered });
        }
      });

      return responses;
    },

    end: function end() {
      if (this.intervention.files.length < 2) {
        this.$toast.bottom('Veuillez prendre une photo du PM avant et après intervention');
        return false;
      }
      this.uploadPicture();
    },
    openConfirmModal: function openConfirmModal() {
      if (!this.isFormValid) {
        this.$toast.bottom('Vous n\'avez pas fini de renseigner cette position');
        return false;
      }

      if (!this.confirmReponses) {
        return this.$modal.show('confirmation');
      }
    },

    finalize: function finalize() {
      this.$modal.hide('confirmation');
      this.saveReponses();
      this.start = false;
      this.finalized = true;
      this.photoAfter = true;
    },
    selectPicture: function selectPicture() {
      this.$refs.fileInput.click();
    },
    uploadPicture: function uploadPicture() {
      if (this.waiting.position >= this.intervention.files.length) {
        this.upload = false;
        this.waiting.position = 0;
        this.waiting.total = 0;
        this.intervention.files.length = 0;
        this.send();
      } else {
        this.upload = true;
        this.waiting.total = this.intervention.files.length;
        this.message = 'Upload ' + this.waiting.position + '/' + this.waiting.total;
        this.uploadPictureServer(this.intervention.files[this.waiting.position]);
      }
    },
    uploadPictureServer: function uploadPictureServer(data) {
      var _this5 = this;

      this.$http.post('intervention/' + this.intervention_id + '/photo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        _this5.response = response.json().then(function (data) {
          _this5.waiting.position++;
          _this5.uploadPicture();
        });
      }, function (response) {
        console.log(response);
      });
    },
    rename: function rename(file) {
      file.description = prompt('Nommer la photo', file.description);
      this.$setItem(this.intervention_id, this.intervention, function (err) {
        if (err) alert(err);
      });
      this.$forceUpdate();
    },
    deleteFile: function deleteFile(file) {
      var i = this.intervention.files.indexOf(file);
      if (i !== -1) {
        this.intervention.files.splice(i, 1);
      }
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      var _this = this;

      var _loop = function _loop(i) {
        var file = files[i];

        if (!(file instanceof File)) {
          return 'continue';
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            var maxWidth = 1024;
            var maxHeight = 768;
            var imageWidth = image.width;
            var imageHeight = image.height;

            if (imageWidth > imageHeight) {
              if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth;
                imageWidth = maxWidth;
              }
            } else {
              if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight;
                imageHeight = maxHeight;
              }
            }
            var canvas = document.createElement('canvas');
            canvas.width = imageWidth;
            canvas.height = imageHeight;
            image.width = imageWidth;
            image.height = imageHeight;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(this, 0, 0, imageWidth, imageHeight);
            _this.intervention.files.push({
              image: canvas.toDataURL(file.type).replace('jpeg', 'jpg').replace('png', 'jpg'),
              description: file.name.replace('.jpeg', '').replace('.jpg', '').replace('.png', '')
            });
            _this.$forceUpdate();
            _this.$setItem(_this.intervention_id, _this.intervention, function (err) {
              if (err) alert(err);
            });
          };
        };
        reader.readAsDataURL(file);
      };

      for (var i in files) {
        var _ret = _loop(i);

        if (_ret === 'continue') continue;
      }
    },
    previousPosition: function previousPosition() {
      if (this.finalized) {
        this.photoAfter = false;
        this.photoBefore = false;
        this.start = true;
        this.finalized = false;
        var position = this.intervention.pm.findIndex(function (pm) {
          return pm.complete === undefined || pm.complete === false;
        }) - 1;
        this.$set(this.intervention.pm[position], 'selected', true);
        return this.setCurrentPosition(position);
      }

      var previousIndex = this.intervention.pm.slice(0, this.index).reverse().findIndex(function (pm) {
        return pm.selected;
      });

      if (previousIndex !== -1) {
        this.setCurrentPosition(this.index - previousIndex - 1);
      }
    },
    nextPosition: function nextPosition() {
      var _this6 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.isFormValid) {
        return this.$toast.bottom('Vous n\'avez pas fini de renseigner cette position');
      }

      this.saveReponses();

      // "Ajouter" modal
      if (index) {
        this.$modal.hide('new-positions');
        this.$set(this.intervention.pm[index], 'selected', true);
        return this.setCurrentPosition(index);
      }

      // "Suivant" position obligatoire
      if (this.index < this.positionsWithTech.length - 1) {
        this.$set(this.intervention.pm[this.index + 1], 'selected', true);
        return this.setCurrentPosition(this.index + 1);
      }

      // "Suivant" position optionnelle
      var nextWithoutTechIndex = this.positionsWithoutTech.find(function (pos) {
        return pos.index > _this6.index && pos.item.selected;
      });
      if (nextWithoutTechIndex) {
        this.$set(this.intervention.pm[nextWithoutTechIndex.index], 'selected', true);
        return this.setCurrentPosition(nextWithoutTechIndex.index);
      }
    },

    setCurrentPosition: function setCurrentPosition() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.index = position;
      var currentPosition = this.intervention.pm[position];
      if (currentPosition.reponses === undefined) currentPosition.reponses = [];
      if (currentPosition.rop !== undefined && currentPosition.rop && currentPosition.rop.fo !== undefined && currentPosition.rop.fo) {
        var operateurs = [currentPosition.rop.fo.oc1, currentPosition.rop.fo.oc2, currentPosition.rop.fo.oc3, currentPosition.rop.fo.oc4];
        this.intervention.pm[position].oc = operateurs.find(function (o) {
          return o.oc === 'FREE' || o.oc === 'IFTR';
        });
      }

      this.requiredResponses = this.setRequiredResponses(currentPosition.reponses);
    },
    saveReponses: function saveReponses() {
      var checked = document.getElementsByClassName('check');
      this.intervention.pm[this.index]['reponses'] = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(checked), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var e = _step.value;

          this.intervention.pm[this.index]['reponses'].push({ cmd_id: this.intervention.pm[this.index].ref_oc, question_id: e['attributes']['data-question-id']['value'], reponse_id: e['attributes']['data-reponse-id']['value'] });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$setItem(this.intervention_id, this.intervention, function (err) {
        if (err) alert(err);
      });
    },
    send: function send() {
      var _this7 = this;

      var debrief = [];
      var b = void 0;
      for (var i in this.intervention.pm) {
        b = 0;
        if (this.intervention.pm[i].reponses === undefined || this.intervention.pm[i].reponses === null) continue;
        while (b < this.intervention.pm[i].reponses.length) {
          debrief.push(this.intervention.pm[i].reponses[b]);
          b++;
        }
      }
      var data = { debrief: debrief };
      this.$http.post('intervention/' + this.intervention_id + '/action/debrief', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        _this7.$removeItem(_this7.intervention_id);
        _this7.$router.push('/intervention/' + _this7.intervention_id);

        if (response.status !== 200) {
          return _this7.$toast(response.body && response.body.error ? response.body.error : 'Une erreur est survenue lors de l\'enregistrement du debrief');
        }
        return _this7.$toast.bottom('Intervention terminée');
      }).catch(function (err) {
        return _this7.$toast(err || 'Une erreur est survenue');
      });
    },

    startDebrief: function startDebrief() {
      if (!this.intervention.files[0]) {
        this.$toast.bottom('Veuillez prendre une photo du pm avant intervention');
        return false;
      }
      this.photoBefore = false;
      this.start = true;
      this.finalized = false;
      var position = this.intervention.pm.findIndex(function (pm) {
        return pm.complete === undefined || pm.complete === false;
      });
      if (position === -1) position = this.intervention.pm.length - 1;
      this.$set(this.intervention.pm[position], 'selected', true);
      this.setCurrentPosition(position);
    },
    stopAudit: function stopAudit() {
      if (confirm('Etes vous sûr de vouloir terminer l\'intervention tout de suite ? Il vous reste des positions à auditer.')) {
        if (this.isFormValid) this.saveReponses();
        this.start = false;
        this.photoAfter = true;
      }
    },
    updatePositions: function updatePositions() {
      var interventionPmWithIndices = this.intervention.pm.map(function (item, index) {
        return { item: item, index: index };
      });
      this.positionsWithTech = interventionPmWithIndices.filter(function (e) {
        return e.item.tech_id;
      });
      this.positionsWithoutTech = interventionPmWithIndices.filter(function (e) {
        return !e.item.tech_id;
      });
    }
  },
  created: function created() {
    var _this8 = this;

    this.intervention_id = this.$route.params.intervention_id;
    this.debrief = JSON.parse(localStorage.getItem('debrief_' + this.intervention_id));
    this.$getItem(this.intervention_id, function (err, values) {
      if (err) {
        return;
      }
      _this8.intervention = values;
      if (_this8.intervention.dateFin !== '00-00-00 00:00:00' && _this8.intervention.dateFin !== null || values.pm === undefined || values.pm === null) {
        _this8.$router.push('/intervention/' + _this8.intervention_id);
      }
      if (_this8.intervention.files === undefined) _this8.intervention.files = [];
      _this8.photoBefore = true;
    });
  }
});

/***/ }),

/***/ "Q8iu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QTf3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'authentification',
  data: function data() {
    return {
      User: {
        login: null,
        password: null,
        token: null
      },
      message: null,
      disabled: false
    };
  },

  methods: {
    login: function login(event) {
      var _this = this;

      if (this.User.login !== '' && this.User.password !== '') {
        this.disabled = 1;
        this.$http.post('user/auth', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.User)).then(function (response) {
          _this.response = response.json().then(function (data) {
            if (data.token) {
              localStorage.setItem('token', data.token);
              localStorage.setItem('login', _this.User.login);
              _this.$clearStorage();
              _this.$router.push('/accueil');
            }
            _this.disabled = false;
          });
        }, function (response) {
          if (response.status === 401) {
            _this.message = 'Humm, il semble que vos identifiants soient incorrects';
          } else {
            _this.message = 'Une erreur inconnue est survenue';
          }
          _this.disabled = false;
        });
      } else {
        this.message = 'Merci de remplir tous les champs';
      }
    }
  },
  mounted: function mounted() {
    localStorage.removeItem('token');
    localStorage.removeItem('login');
    localStorage.removeItem('password');
  }
});

/***/ }),

/***/ "SdDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testarbre"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"label"},[_c('i',{staticClass:"fa fa-cog fa-spin fa-3x fa-fw"}),_vm._v(" "),_c('br'),_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]):_vm._e()]),_vm._v(" "),_c('b-container',{class:{fixe: ! _vm.selected}},[_c('b-form-select',{class:{fixe: ! _vm.selected},attrs:{"options":_vm.options},on:{"change":function($event){_vm.getArbre($event)}},model:{value:(_vm.selectedArbre),callback:function ($$v) {_vm.selectedArbre=$$v},expression:"selectedArbre"}}),_vm._v(" "),(_vm.selected)?_c('debrief',{staticClass:"debrief",attrs:{"isTest":true}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U+l5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VBL2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VUkn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VoxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestArbre_vue__ = __webpack_require__("y8dM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6b23a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestArbre_vue__ = __webpack_require__("SdDS");
function injectStyle (ssrContext) {
  __webpack_require__("CYrB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e6b23a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestArbre_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6b23a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestArbre_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WI0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interventions"},[_c('div',{staticClass:"header-intervention"},[_c('div',{staticClass:"header-info"},[_vm._v("\n     Mon compte\n    ")]),_vm._v(" "),_c('div',{staticClass:"button-content"},[_c('div',{staticClass:"button",on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-sign-out",attrs:{"aria-hidden":"true"}}),_vm._v(" Déconnexion\n      ")])])]),_vm._v(" "),_c('b-container',{staticClass:"account-content"},[_c('div',{staticClass:"information"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Informations personnelles")])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"label"},[_c('b',[_vm._v("Nom : ")]),_vm._v(" "+_vm._s(_vm.account.nom)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Prénom : ")]),_vm._v(" "+_vm._s(_vm.account.prenom)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Login : ")]),_vm._v(" "+_vm._s(_vm.account.login)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Mail : ")]),_vm._v(" "+_vm._s(_vm.account.mail)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Entreprise : ")]),_vm._v(" "+_vm._s(_vm.account.entreprise)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("\n     Votre session expire dans "+_vm._s(_vm.token())+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X7DP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YMLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intervention_vue__ = __webpack_require__("mVH3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e35c8e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intervention_vue__ = __webpack_require__("yLHR");
function injectStyle (ssrContext) {
  __webpack_require__("CRM0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e35c8e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intervention_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e35c8e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intervention_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Interventions__ = __webpack_require__("+zgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Intervention__ = __webpack_require__("YMLW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Debrief__ = __webpack_require__("JmD1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Account__ = __webpack_require__("uK6g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AuditPM__ = __webpack_require__("zQ9N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AuditConstatation__ = __webpack_require__("eZrJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Authentification__ = __webpack_require__("OCiJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Scan__ = __webpack_require__("vJ5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Accueil__ = __webpack_require__("pHOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TestArbre__ = __webpack_require__("VoxN");













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/app',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Home__["a" /* default */],
    children: [{
      path: '/interventions/:type/:status',
      component: __WEBPACK_IMPORTED_MODULE_2__components_Interventions__["a" /* default */]
    }, {
      path: '/intervention/:intervention_id',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Intervention__["a" /* default */]
    }, {
      path: '/intervention/:intervention_id/debrief',
      component: __WEBPACK_IMPORTED_MODULE_4__components_Debrief__["a" /* default */]
    }, {
      path: '/intervention/:intervention_id/auditpm',
      component: __WEBPACK_IMPORTED_MODULE_6__components_AuditPM__["a" /* default */]
    }, {
      path: '/intervention/:intervention_id/auditconstatation',
      component: __WEBPACK_IMPORTED_MODULE_7__components_AuditConstatation__["a" /* default */]
    }, {
      path: '/account',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Account__["a" /* default */]
    }, {
      path: '/scan',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Scan__["a" /* default */]
    }, {
      path: '/accueil',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Accueil__["a" /* default */]
    }, {
      path: '/testarbre',
      component: __WEBPACK_IMPORTED_MODULE_12__components_TestArbre__["a" /* default */]
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Authentification__["a" /* default */]
  }, {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ "ZHzv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interventions"},[_vm._m(0),_vm._v(" "),_c('b-container',{staticClass:"account-content"},[_c('div',{staticClass:"inter"},[_c('div',{staticClass:"type",on:{"click":function($event){_vm.buttonTypeMenu('/interventions/postprodsav/open')}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-code-fork",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"texte"},[_vm._v("PostProd / SAV")])])]),_vm._v(" "),_c('div',{staticClass:"type",on:{"click":function($event){_vm.buttonTypeMenu('/interventions/prod/open')}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-cogs",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"texte"},[_vm._v("Prod")])])])]),_vm._v(" "),_c('div',{staticClass:"compte"},[_c('div',{staticClass:"type",on:{"click":function($event){_vm.buttonTypeMenu('/interventions/audit/open')}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-list",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"texte"},[_vm._v("Audit")])])]),_vm._v(" "),_c('div',{staticClass:"type",on:{"click":function($event){_vm.buttonTypeMenu('/interventions/auditpm/open')}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-list",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"texte"},[_vm._v("Audit PM")])])])]),_vm._v(" "),_c('div',{staticClass:"compte"},[_c('div',{staticClass:"type",on:{"click":function($event){_vm.buttonTypeMenu('/account')}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"texte"},[_vm._v("Mon compte")])])]),_vm._v(" "),_c('div',{staticClass:"type",on:{"click":function($event){_vm.buttonTypeMenu('/testarbre')}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-tree",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"texte"},[_vm._v("Test des arbres")])])])]),_vm._v(" "),_c('div',{staticClass:"compte"},[_c('div',{staticClass:"type",on:{"click":_vm.logout}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-sign-out",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"texte"},[_vm._v("Déconnexion")])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-intervention"},[_c('div',{staticClass:"header-info"},[_vm._v("\n      Accueil\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "as/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quagga__ = __webpack_require__("SGD2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quagga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quagga__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // ES6
__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('fr');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Account',
  data: function data() {
    return {
      account: {}
    };
  },

  methods: {
    StartScan: function StartScan() {
      $('#interactive').removeClass('hide');
      $('#manuelle').addClass('hide');
      $('#result').addClass('hide');
      __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.init({
        inputStream: {
          type: 'LiveStream',
          constraints: {
            width: { min: 100 },
            height: { min: 100 },
            aspectRatio: { min: 1, max: 100 },
            facingMode: 'environment' // or "user" f  or the front camera
          }
        },
        locator: {
          patchSize: 'medium',
          halfSample: true
        },
        numOfWorkers: navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4,
        decoder: {
          readers: ['code_128_reader']
        },
        locate: true
      }, function (err) {
        if (err) {
          console.log(err);
          return;
        }
        __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.start();
      });
      __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.onProcessed(function (result) {
        var drawingCtx = __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.canvas.ctx.overlay;
        var drawingCanvas = __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.canvas.dom.overlay;

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')));
            result.boxes.filter(function (box) {
              return box !== result.box;
            }).forEach(function (box) {
              __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: 'green', lineWidth: 2 });
            });
          }

          if (result.box) {
            __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 });
          }

          if (result.codeResult && result.codeResult.code) {
            __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.onDetected(function (result) {
        if (result.codeResult.code) {
          $('#scanner_input').val(result.codeResult.code);
          $('#interactive').addClass('hide');
          $('#manuelle').addClass('hide');
          $('#result').removeClass('hide');
          __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.stop();
        }
      });
    },
    CloseScan: function CloseScan() {
      $('#interactive').addClass('hide');
      $('#manuelle').removeClass('hide');
      $('#result').addClass('hide');
      var scanhisto = $('#scanner_input').val();
      if (scanhisto) {
        $('#scanne_manuel').val(scanhisto);
      }
      if (__WEBPACK_IMPORTED_MODULE_1_quagga___default.a) {
        __WEBPACK_IMPORTED_MODULE_1_quagga___default.a.stop();
      }
    },
    envoiScan: function envoiScan() {
      var scan = $('#scanne_manuel').val();
      $('#scanner_input').val(scan);
      $('#interactive').addClass('hide');
      $('#manuelle').addClass('hide');
      $('#result').removeClass('hide');
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "bWPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AuditConstatation',
  props: {
    isTest: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selected: '',
      photo: true,
      types_photo: [], // contient les photos qui doivent obligatoirement être ajoutée
      files: [], // contient les photos ajoutée à l'initiative de l'utilisateur
      intervention_id: null,
      debrief: {},
      reponse_count: 0,
      intervention: {},
      upload: false,
      message: '',
      debrief_started: false,
      waiting: {
        position: 0,
        total: 0
      },
      wrapper_class: 'debrief-content'
    };
  },

  methods: {
    back: function back() {
      this.$router.push('/intervention/' + this.intervention_id);
    },
    backPhoto: function backPhoto() {
      this.debrief_started = false;
      this.photo = true;
    },
    startDebrief: function startDebrief() {
      var _this2 = this;

      if (this.types_photo.find(function (type) {
        return !type.image;
      })) {
        this.$toast('Il manque la photo ' + this.types_photo.find(function (type) {
          return !type.image;
        }).description);
        return false;
      }
      this.intervention.files = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.types_photo), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.files));
      this.$setItem(this.intervention_id, this.intervention, function (err) {
        if (err) alert(err);
        _this2.photo = false;
        _this2.debrief_started = true;
        window.scrollTo(0, 0);
      });
    },

    setPicture: function setPicture() {
      var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (file) this.selected = file.description;
      this.$refs.fileInput.click();
    },
    uploadPicture: function uploadPicture() {
      var files = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.types_photo), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.files));
      if (this.waiting.position >= files.length) {
        this.upload = false;
        this.waiting.position = 0;
        this.waiting.total = 0;
        this.files.length = 0;
        this.send();
      } else {
        this.upload = true;
        this.waiting.total = files.length;
        this.message = 'Upload ' + this.waiting.position + '/' + this.waiting.total;
        this.uploadPictureServer(files[this.waiting.position]);
      }
    },
    uploadPictureServer: function uploadPictureServer(data) {
      var _this3 = this;

      this.$http.post('intervention/' + this.intervention_id + '/photo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        _this3.response = response.json().then(function (data) {
          _this3.waiting.position++;
          _this3.uploadPicture();
        });
      }, function (response) {
        console.log(response);
      });
    },
    rename: function rename(file) {
      file.description = prompt('Nommer la photo', file.description);
    },
    getTypesPhoto: function getTypesPhoto() {
      var _this4 = this;

      this.$http.get('typephoto').then(function (response) {
        _this4.types_photo = response.body.filter(function (elt) {
          return elt.type_intervention_id === _this4.intervention.typeId;
        }).map(function (type) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, type, { description: type.nom, required: true });
        });
      }).catch(function () {
        return _this4.$toast.bottom('Les types de photo n\'ont pas pu être chargés.');
      });
    },

    deleteFile: function deleteFile(file) {
      var i = this.files.indexOf(file);
      if (i !== -1) {
        this.files.splice(i, 1);
      }
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      var _this = this;

      var _loop = function _loop(i) {
        var file = files[i];

        if (!(file instanceof File)) {
          return 'continue';
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            var maxWidth = 1024;
            var maxHeight = 768;
            var imageWidth = image.width;
            var imageHeight = image.height;

            if (imageWidth > imageHeight) {
              if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth;
                imageWidth = maxWidth;
              }
            } else {
              if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight;
                imageHeight = maxHeight;
              }
            }
            var canvas = document.createElement('canvas');
            canvas.width = imageWidth;
            canvas.height = imageHeight;
            image.width = imageWidth;
            image.height = imageHeight;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(this, 0, 0, imageWidth, imageHeight);
            if (_this.selected) {
              _this.types_photo = _this.types_photo.map(function (type) {
                if (type.description !== _this.selected) return type;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, type, { image: canvas.toDataURL(file.type).replace('jpeg', 'jpg').replace('png', 'jpg') });
              });
              _this.selected = null;
            } else {
              _this.files.push({
                image: canvas.toDataURL(file.type).replace('jpeg', 'jpg').replace('png', 'jpg'),
                description: file.name.replace('.jpeg', '').replace('.jpg', '').replace('.png', '')
              });
            }
            _this.$refs.fileInput.value = '';
          };
        };
        reader.readAsDataURL(file);
      };

      for (var i in files) {
        var _ret = _loop(i);

        if (_ret === 'continue') continue;
      }
    },
    send: function send() {
      var _this5 = this;

      var send = [];
      $('.content > .question').each(function (index) {
        if ($(this).is(':visible')) {
          if ($(this).find('.reponse-button').hasClass('check')) {
            send.push({
              question_id: $(this).find('.reponse-button.check').data('question-id'),
              response_id: $(this).find('.reponse-button.check').data('reponse-id')
            });
          }
          if ($(this).find('.reponse-input > input').val() !== '' && $(this).find('.reponse-input > input').val() !== undefined) {
            send.push({
              question_id: $(this).find('.reponse-input').data('question-id'),
              response_id: null,
              response_text: $(this).find('.reponse-input > input').val()
            });
          }
        }
      });
      this.$http.post('intervention/' + this.intervention_id + '/action/debrief', { debrief: send }).then(function (response) {
        _this5.$removeItem(_this5.intervention_id);
        _this5.$router.push('/intervention/' + _this5.intervention_id);
        _this5.$toast.bottom('Intervention terminée');
      }).catch(function (err) {
        if (err.status === 403) {
          _this5.$router.push('/intervention/' + _this5.intervention_id);
          _this5.$toast.bottom('Le debrief n\'a pas pu être debriefer car la date de rendez vous a été modifié !');
        }
        _this5.$toast.bottom('Une erreur est survenue lors de l\'envoi du debrief');
      });
    },
    count: function count() {
      var t = 0;
      $('.content > .question').each(function (index) {
        if ($(this).data('required')) {
          if ($(this).is(':visible')) {
            if ($(this).has('.reponse-button').length !== 0) {
              if ($(this).find('.reponse-button').not('.check').length === $(this).find('.reponse-button').length) {
                t++;
              }
            }
            if ($(this).find('.reponse-input > input').val() === '') {
              t++;
            }
          }
        }
      });
      this.reponse_count = t;
    },
    arbre: function arbre(debrief) {
      var html = '';
      for (var i in debrief) {
        var required = '';
        if (debrief[i]['required']) {
          required = '<div class="required">( Réponse obligatoire )</div>';
        }
        html += '<div class="content debrief"><div class="question" data-required="' + debrief[i]['required'] + '" data-question-id="' + debrief[i]['question_id'] + '"> <div class="label">' + debrief[i]['question_label'] + ' ' + required + '</div>';
        for (var b in debrief[i]['reponse']) {
          html += '<div class="reponse-button action" data-question-id="' + debrief[i]['question_id'] + '" data-reponse-id="' + debrief[i]['reponse'][b]['reponse_id'] + '"><i class="fa fa-check hide" aria-hidden="true"></i> ' + debrief[i]['reponse'][b]['reponse_label'] + '</div>';
        }
        if (debrief[i]['custom_response']) {
          html += '<div class="reponse-input" data-question-id="' + debrief[i]['question_id'] + '"><input type="text" placeholder="Votre réponse"/></div>';
        }
        html += '</div>';
        for (var _b in debrief[i]['reponse']) {
          if (debrief[i]['reponse'][_b]['next_question'] !== null) {
            html += '<div class="child next_question_' + debrief[i]['reponse'][_b]['reponse_id'] + '"> ' + this.recursive(debrief[i]['reponse'][_b]['next_question'], '') + '</div>';
          }
        }
        html += '</div>';
      }
      $('.content-arbre').append(html);
      var _this = this;
      $('.reponse-input > input').keyup(function () {
        _this.count();
      });
      $('.action').on('click', function () {
        // let id = $(this).data('reponse-id')
        $(this).parent().find('.action').each(function (index) {
          $(this).removeClass('check');
          $(this).find('.fa').addClass('hide');
        });
        $(this).parent().parent().find('.child').each(function (index) {
          $(this).children('.content').hide();
        });
        $(this).addClass('check');
        $(this).find('.fa').removeClass('hide');
        $(this).parent().parent().find('.child').children('.content').find('.condition').each(function (index) {
          var json = JSON.parse($(this).text());
          var ok = 0;
          var count = json.length === undefined ? 0 : json.length;
          for (var _i in json) {
            var id = json[_i]['reponse_id'];
            if (json[_i]['has_this_value'] === 0) {
              if (!$('[data-reponse-id="' + id + '"]').hasClass('check')) {
                ok++;
              }
            } else {
              if ($('[data-reponse-id="' + id + '"]').hasClass('check')) {
                ok++;
              }
            }
          }
          if (ok === count) {
            $(this).parent().show();
          }
        });

        _this.count();
      });

      this.count();
    },
    recursive: function recursive(data, html) {
      for (var i in data) {
        var required = '';
        if (data[i]['required']) {
          required = '<div class="required">( Réponse obligatoire )</div>';
        }
        html += '<div class="content debrief sub hide"><div class="condition hide">' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data[i]['condition']) + '</div><div class="question" data-required="' + data[i]['required'] + '" data-question-id="' + data[i]['question_id'] + '"> <div class="label">' + data[i]['question_label'] + ' ' + required + '</div>';
        for (var b in data[i]['reponse']) {
          html += '<div class="reponse-button action" data-question-id="' + data[i]['question_id'] + '" data-reponse-id="' + data[i]['reponse'][b]['reponse_id'] + '"><i class="fa fa-check hide" aria-hidden="true"></i> ' + data[i]['reponse'][b]['reponse_label'] + '</div>';
        }
        if (data[i]['custom_response']) {
          html += '<div class="reponse-input" data-question-id="' + data[i]['question_id'] + '"><input type="text" placeholder="Votre réponse"/></div>';
        }
        html += '</div>';
        for (var _b2 in data[i]['reponse']) {
          if (data[i]['reponse'][_b2]['next_question'] !== null) {
            html += '<div class="child next_question_' + data[i]['reponse'][_b2]['reponse_id'] + '"> ' + this.recursive(data[i]['reponse'][_b2]['next_question'], '') + '</div>';
          }
        }
        html += '</div>';
      }
      return html;
    }
  },
  mounted: function mounted() {
    this.photo = true;
    this.$modal.hide('selector');
    var _this = this;
    this.intervention_id = this.$route.params.intervention_id;
    var data = localStorage.getItem('debrief_' + this.intervention_id);
    this.$getItem(this.intervention_id, function (err, intervention) {
      if (err) return;
      _this.intervention = intervention;
      if (!intervention.files) _this.getTypesPhoto();else {
        _this.types_photo = intervention.files.filter(function (file) {
          return file.required;
        });
        _this.files = intervention.files.filter(function (file) {
          return !file.required;
        });
      }
    });

    if (data) {
      this.debrief = JSON.parse(data);
      this.arbre(this.debrief);
    }
  }
});

/***/ }),

/***/ "dft9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAEy0lEQVR4Xu2dgVHcMBBFVxWQDgIdpIOQCpJUEKggpIKQCnKpAOggqSDQAR0EOggVbOYzcsZjfNjf3Eq6u68Zz3HD4pX/0+5KuhuUbEuau78ys7dm9iZfeI+f8dpvf83s1sy6V/x8k1LC++ZbarmH7g7BP5nZBzM7fGFf78zsp5ldpZQAqcnWHJAcCe/N7HwDENaJDji4/6/WIqcZIBnEZzM7G0lDUaMZaWxlZj9aAdMEEHcHCIzYYT0YgrjJ9QEpB6P8LqWE1//N3ZHauqurN6g9zzWAOUspXUWRn3vfqkCyeBdmdvxMhyHSNfL/0lGcow91CBfS4boGP6dDyHPF3IRdNSDuDnEAYywqHnIqWS2FsE6cDAdpEdfBiB2iBVAwASjeqgBxd0TE75GnDQMx9DUDzMcaUKoAgTjufpmntJ1WqA8npdNFTpvoS7/OYGp8Ujw8zKwakAGULyklzHaqNXdHCvue0xUAVWlVgWQoh0xU5MUiRjPSHupPN6PC7R5nXnmVjgKNFfrsRSDS2KZrFku1OpA5He6tUZBG2BU7AGHEN7PWeO6ZmwaSQXxFbZmxRplii9kTwHyrHQVbCSTPxDAtZiNiCgwiBtNapLTmWrMR4u6ICgAZNkyNISYu1IfbbsTniOpW56gxuMbWGtVmUVMjoFkgueD3odzn7ZXZK/YMCPfADOp1FqNZGOhf00AylG6zcfGqvbcIxIyuyvpiKjK63zcPZO6D7IqdgDRGUkAEpDEFGuuOImTfgbxwG6SUfNW2W4pGSN4YxOcgUx/VlhJ+yg+2W94xG5RTN5z6fTEgOTL+bBGMTjtAOSq1/1USCD7vwJcZtrFhpxgL1PBWEgiio79R2OwWxsinmfh2y1E4jZJbJ+7u/QdKKRUbDEuErNXfYqLUesAlMPIeWpUBJCBriNUaQNWALB25tf6uVIoVkJmEBWSmUKXMBKSU0jP97DyQUg84U+8nZntX1AVkfKhUK+oCIiBU9lLKouSKNxaQeI0pDwJCyRVvLCDxGlMeBISSK95YQOI1pjwICCVXvLGAxGtMeRAQSq54YwGJ15jyICCUXPHGAhKvMeVBQCi54o0FJF5jyoOAUHLFGwtIvMaUBwGh5Io3FpB4jSkPAkLJFW8sIPEaUx4EhJIr3lhA4jWmPAgIJVe8sYDEa0x5EBBKrnhjAYnXmPIgIJRc8cYCEq8x5UFAKLnijQUkXmPKg4BQcsUbC0i8xpQHAaHkijcWkHiNKQ8CQskVbywg8RpTHgSEkiveWEDiNaY8CAglV7yxgMRrTHkQEEqueGMBideY8iAglFzxxgISrzHlQUAoueKNBSReY8rD3gGh1GnAuNT/96r2D8wa0JjqgoBQcsUbC0i8xpSHnQdS6gEp1XvGe1fUBWR8qFQr6iyQfDYuTo5mDyvGeVI4IZo6tF4RMpFb3H14IAyTjegDWQRkGghGenfAMAMDtvcpJSqyBGQaCA4VPl8A5fGUaaWsgcC1RhwbSp19rf6WLOrDlHOZUjpdKljk37n7hZn1j/mmU97S/pUEss3H5mGWhnQZ3koCwemeiJKD8KfarIMHTLV37mBJaJSPXr3eIiiAcbyTR6/2iiUiBadmIkcvncZuNgae3g0zMywkV6Uio+vCP7ZuC5L9Z4mOAAAAAElFTkSuQmCC"

/***/ }),

/***/ "e195":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e7Rj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eGWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interventions"},[_c('div',{staticClass:"header-intervention"},[_c('div',{staticClass:"intervention-type"},[_vm._v("\n      "+_vm._s(_vm.getTypeLabel())+"\n    ")]),_vm._v(" "),_c('b-button-group',{staticClass:"group",attrs:{"size":"sm"}},[_c('b-button',{attrs:{"pressed":_vm.open,"variant":"outline-danger"},on:{"update:pressed":function($event){_vm.open=$event},"click":function($event){_vm.buttonTypeIntervention('open')}}},[_vm._v("En cours")]),_vm._v(" "),_c('b-button',{attrs:{"pressed":_vm.close,"variant":"outline-danger"},on:{"update:pressed":function($event){_vm.close=$event},"click":function($event){_vm.buttonTypeIntervention('close')}}},[_vm._v("Terminées")])],1)],1),_vm._v(" "),_c('b-container',{staticClass:"interventions-list"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.cache)?_c('b-alert',{staticClass:"cache",attrs:{"variant":"warning","show":""}},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_vm._v(" Cache activé "),_c('br'),_vm._v(" Tirez pour synchroniser ou "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.sync}},[_vm._v("cliquez ici")])]):_vm._e()],1),_vm._v(" "),(!_vm.isNotEmpty(_vm.interventions) && !_vm.loading)?_c('div',{staticClass:"message"},[_c('i',{staticClass:"fa fa-info",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('br'),_vm._v("\n      Aucune intervention de "+_vm._s(_vm.getTypeLabel())+" disponible.\n    ")]):_vm._e(),_vm._v(" "),(!_vm.cache && _vm.loading && !_vm.isNotEmpty(_vm.interventions))?_c('div',{staticClass:"intervention"},[_c('div',{staticClass:"shimmer shimmer-progress"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label-small"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label-small"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label-small"})]):_vm._e(),_vm._v(" "),_vm._l((_vm.orderBy(_vm.interventions, 'dateRdv')),function(intervention){return (_vm.type !== 'audit')?_c('div',{staticClass:"intervention",on:{"click":function($event){_vm.goToIntervention(intervention.interventionId)}}},[_c('b-progress',{attrs:{"max":100}},[_c('b-progress-bar',{attrs:{"value":_vm.progressBar(intervention, 'percent'),"variant":_vm.progressBar(intervention,'className'),"striped":"","animated":_vm.progressBar(intervention,'animated')}},[_vm._v("\n             "+_vm._s(_vm.progressBar(intervention,'value'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"type"},[_vm._v("\n          "+_vm._s(intervention.typeReference)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n          NRO : "+_vm._s(intervention.nro === null ? intervention.codeNro : intervention.nro)+"\n        ")]),_vm._v(" "),(intervention.auditinfra)?_c('div',{staticClass:"label"},[_vm._v("\n          PM : "+_vm._s(intervention.nomPm)+"\n        ")]):_vm._e(),_vm._v(" "),(!intervention.auditinfra)?_c('div',{staticClass:"label"},[_vm._v("\n          Jeton : "+_vm._s(intervention.jeton)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n          RDV Client :\n          "),(intervention.rdvClient)?_c('i',{staticClass:"fa fa-check green-color",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!intervention.rdvClient)?_c('i',{staticClass:"fa fa-times red-color",attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n          Date du RDV : "+_vm._s(_vm.formatDate(intervention.dateRdv))+"\n        ")])],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.orderBy(_vm.interventions, 'dateRdv')),function(intervention){return (_vm.type === 'audit')?_c('div',{staticClass:"intervention",on:{"click":function($event){_vm.goToIntervention(intervention.interventionId)}}},[_c('b-progress',{attrs:{"max":100}},[_c('b-progress-bar',{attrs:{"value":_vm.progressBar(intervention, 'percent'),"variant":_vm.progressBar(intervention,'className'),"striped":"","animated":_vm.progressBar(intervention,'animated')}},[_vm._v("\n          "+_vm._s(_vm.progressBar(intervention,'value'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"type"},[_vm._v("\n        "+_vm._s(intervention.descr)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n        NRO : "+_vm._s(intervention.nro)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n        Jeton : "+_vm._s(intervention.jeton)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n        RDV Client :\n        "),(intervention.rdvClient)?_c('i',{staticClass:"fa fa-check green-color",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!intervention.rdvClient)?_c('i',{staticClass:"fa fa-times red-color",attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n        Date du RDV : "+_vm._s(_vm.formatDate(intervention.dateRdv))+"\n      ")])],1):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eZrJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditConstatation_vue__ = __webpack_require__("bWPr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148bffbf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditConstatation_vue__ = __webpack_require__("ygFs");
function injectStyle (ssrContext) {
  __webpack_require__("VBL2")
  __webpack_require__("Q8iu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-148bffbf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditConstatation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148bffbf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditConstatation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "ia2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kBR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["a"] = (SignaturePad);


/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "l4aH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debrief"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.upload)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"label"},[_c('i',{staticClass:"fa fa-cog fa-spin fa-3x fa-fw"}),_vm._v(" "),_c('br'),_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"header-intervention"},[_c('div',{staticClass:"header-info"},[_vm._v("\n      "+_vm._s(_vm.showCountLabel(_vm.reponse_count))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"button-content"},[(!_vm.auditPhoto && (!_vm.signature || _vm.audit))?_c('div',{staticClass:"button",on:{"click":function($event){_vm.back()}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}}),_vm._v(" Annuler\n      ")]):_vm._e(),_vm._v(" "),((_vm.auditPhoto || _vm.signature))?_c('div',{staticClass:"button",on:{"click":function($event){_vm.signatureBack()}}},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Retour\n      ")]):_vm._e(),_vm._v(" "),(_vm.signature && _vm.checked || _vm.audit && _vm.auditPhoto)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.send()}}},[_c('i',{staticClass:"fa fa-paper-plane",attrs:{"aria-hidden":"true"}}),_vm._v(" Envoyer\n      ")]):_vm._e(),_vm._v(" "),(_vm.reponse_count === 0 && _vm.auditPhoto && !_vm.audit)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.signatureShow()}}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v(" Signature\n      ")]):_vm._e(),_vm._v(" "),(_vm.reponse_count === 0 && !_vm.auditPhoto && !_vm.signature)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.signatureShow()}}},[_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}}),_vm._v(" Photo\n      ")]):_vm._e()])]),_vm._v(" "),_c('b-container',{class:_vm.wrapper_class},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.signature && !_vm.auditPhoto),expression:"!signature && !auditPhoto"}],staticClass:"etatBox"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getEtat(_vm.intervention))}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.signature && !_vm.auditPhoto),expression:"!signature && !auditPhoto"}],staticClass:"content-arbre"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.auditPhoto),expression:"auditPhoto"}],staticClass:"photo"},[_vm._l((_vm.files),function(file){return _c('div',{staticClass:"picture"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(file.description))]),_vm._v(" "),_c('img',{staticClass:"preview",attrs:{"src":file.image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"options"},[(_vm.audit)?_c('div',{staticClass:"rename",on:{"click":function($event){_vm.rename(file)}}},[_vm._v("Renommer")]):_vm._e(),_vm._v(" "),(!_vm.audit)?_c('div',{staticClass:"rename",on:{"click":function($event){_vm.renameSelector(file)}}},[_vm._v("Renommer")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"delete",on:{"click":function($event){_vm.deleteFile(file)}}},[_vm._v("Supprimer")])])])}),_vm._v(" "),_c('div',{staticClass:"buttonPhoto",on:{"click":_vm.selectPicture}},[_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}}),_vm._v(" Ajouter des photos\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.files.length !== 0),expression:"files.length !== 0"}],staticClass:"buttonPhoto",on:{"click":_vm.uploadPicture}},[_c('i',{staticClass:"fa fa-cloud-upload",attrs:{"aria-hidden":"true"}}),_vm._v(" Envoyer les photos\n      ")]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","accept":"image/*","multiple":""},on:{"change":_vm.onFileChange}})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signature && !_vm.audit),expression:"signature && !audit"}],staticClass:"signature"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" En cochant la case, Je déclare avoir effectué et terminé mon intervention.\n      "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked),expression:"checked"}]},[(_vm.intervention.rdvClient)?_c('div',{staticClass:"rules"},[_vm._v("\n           Signature de Mme ou M. "+_vm._s(_vm.getData('cmdAcces', 'clientNom'))+" "+_vm._s(_vm.getData('cmdAcces', 'clientPrenom'))+" (ou son représentant) :\n        ")]):_vm._e(),_vm._v(" "),(!_vm.intervention.rdvClient)?_c('div',{staticClass:"rules"},[_vm._v("\n          Signature du technicien\n        ")]):_vm._e(),_vm._v(" "),_c('canvas',{staticClass:"signature-pad",attrs:{"id":"signature-pad"}}),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":function($event){_vm.reset()}}},[_c('i',{staticClass:"fa fa-eraser",attrs:{"aria-hidden":"true"}}),_vm._v(" Réinitialiser\n        ")])])]),_vm._v(" "),_c('modal',{attrs:{"name":"selector","width":"360","height":"70"}},[_c('div',{staticClass:"title-selector"},[_vm._v("\n        Sélection du nom de la photo :\n      ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.closModal()}]}},_vm._l((_vm.type_photo),function(type){return (_vm.intervention.typeId === type.type_intervention_id)?_c('option',{domProps:{"value":type.nom}},[_vm._v(_vm._s(type.nom))]):_vm._e()}))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac07f250_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("I6Hl");
function injectStyle (ssrContext) {
  __webpack_require__("Mh7V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac07f250_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mVH3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_pulltorefresh__ = __webpack_require__("nqTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quagga__ = __webpack_require__("SGD2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quagga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_quagga__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // ES6
__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('fr');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Interventions',
  data: function data() {
    return {
      intervention_id: null,
      backLabel: 'Retour',
      cache: false,
      messageLoading: '<i class="fa fa-refresh fa-spin"></i> Récupération de l\'intervention',
      intervention: {},
      fibre: '',
      onu: {
        sn1: '',
        sn2: '',
        sn3: ''
      },
      scanChoix: null,
      request: false,
      start: false,
      message: null,
      audit: false,
      auditconstatation: false,
      auditinfra: false,
      checkBox: false,
      state: {
        inputStream: {
          type: 'LiveStream',
          constraints: {
            width: { min: 100 },
            height: { min: 100 },
            aspectRatio: { min: 1, max: 100 },
            facingMode: 'environment' // or "user" f  or the front camera
          }
        },
        locator: {
          patchSize: 'medium',
          halfSample: true
        },
        numOfWorkers: navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4,
        decoder: {
          readers: ['code_128_reader']
        },
        locate: true
      },
      activate: false
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      if (date === undefined) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('dddd DD MMMM à HH:mm');
    },
    scanInit: function scanInit() {
      __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.init(this.state, function (err) {
        if (err) {
          console.log(err);
          return;
        }
        __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.start();
      });
    },
    scan: function scan(choix) {
      this.scanChoix = choix;
      if (this.activate) {
        return this.$toast.bottom('Merci de terminer ou stopper l\'autre scan en cours :)');
      }
      var _this = this;
      _this.activate = true;
      $('#interactive').appendTo('#video_' + choix).removeClass('hide');
      $('#closescan_' + choix).removeClass('hide');
      $('#scan_' + choix).addClass('hide');
      this.scanInit();
      __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.onProcessed(function (result) {
        var drawingCtx = __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.canvas.ctx.overlay;
        var drawingCanvas = __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.canvas.dom.overlay;

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')));
            result.boxes.filter(function (box) {
              return box !== result.box;
            }).forEach(function (box) {
              __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: 'green', lineWidth: 2 });
            });
          }

          if (result.box) {
            __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 });
          }

          if (result.codeResult && result.codeResult.code) {
            __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.onDetected(function (result) {
        if (result.codeResult.code) {
          _this.activate = false;
          if (_this.scanChoix === 1) {
            _this.fibre = result.codeResult.code;
            $('#fibre').val(result.codeResult.code);
          }
          if (_this.scanChoix === 2) {
            _this.onu.sn1 = result.codeResult.code;
            $('#sn1').val(result.codeResult.code);
          }
          if (_this.scanChoix === 3) {
            _this.onu.sn2 = result.codeResult.code;
            $('#sn2').val(result.codeResult.code);
          }
          if (_this.scanChoix === 4) {
            _this.onu.sn3 = result.codeResult.code;
            $('#sn3').val(result.codeResult.code);
          }
          __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.stop();
          $('#interactive').addClass('hide');
          $('#closescan_' + _this.scanChoix).addClass('hide');
          $('#scan_' + _this.scanChoix).removeClass('hide');
        }
      });
    },
    CloseScan: function CloseScan(choix) {
      $('#interactive').addClass('hide');
      $('#closescan_' + choix).addClass('hide');
      $('#scan_' + choix).removeClass('hide');
      this.activate = false;
      if (__WEBPACK_IMPORTED_MODULE_4_quagga___default.a) {
        __WEBPACK_IMPORTED_MODULE_4_quagga___default.a.stop();
      }
    },
    pushKitFibre: function pushKitFibre() {
      var _this2 = this;

      if (this.request) {
        return this.$toast.bottom('Requète en cours');
      }
      if (this.fibre === '') {
        return this.$toast.bottom('Merci de saisir une valeur');
      }
      this.request = true;
      var data = {};
      data.jeton = this.intervention.jeton;
      data.kitBarcode = this.fibre;
      this.$http.post('intervention/barcodeKit', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        _this2.request = false;
        if (response.status === 201) {
          return _this2.$toast.bottom('KitFibre inséré');
        }
        if (response.status === 202) {
          return _this2.$toast.bottom(response.body.message);
        }
        return _this2.$toast.bottom('Une erreur est survenue');
      });
    },
    pushOnu: function pushOnu() {
      var _this3 = this;

      if (this.request) {
        return this.$toast.bottom('Requète en cours');
      }
      if (this.onu.sn1 === '' || this.onu.sn2 === '' || this.onu.sn3 === '') {
        return this.$toast.bottom('Merci de saisir une valeur dans tous les champs "Kit ONU"');
      }
      this.request = true;
      var data = {};
      data.jeton = this.intervention.jeton;
      data.cartonBarcode = this.onu.sn1;
      data.onuBarcode = this.onu.sn2;
      data.sfpBarcode = this.onu.sn3;

      this.$http.post('intervention/barcodeONU', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        _this3.request = false;
        if (response.status === 201) {
          return _this3.$toast.bottom('ONU inséré');
        }
        if (response.status === 202) {
          return _this3.$toast.bottom(response.body.message);
        }
        return _this3.$toast.bottom('Une erreur est survenue');
      });
    },
    getEtat: function getEtat(intervention) {
      var html = '';
      if (intervention.etat === 'OK') {
        html += '<div style="font-size: 60px;color: green;">OK</div>';
      } else if (intervention.etat === 'NOK') {
        html += '<div style="font-size: 60px;color: red;">NOK</div>';
      } else {
        html += '<div style="font-size: 60px;color: orange;">-</div>';
      }
      return html;
    },
    startDebrief: function startDebrief() {
      var _this4 = this;

      if (this.intervention.etat === null && !this.auditinfra) {
        this.start = true;
        this.message = 'Ping BOX en cours';
        this.getEtatBox(this.startDebrief);
        return;
      }
      this.start = true;
      this.message = 'Récupération du debrief';
      var typeId = null;
      for (var i in this.intervention['typeDebrief']) {
        if (this.intervention['typeDebrief'][i]['nom'] === this.intervention.etat) {
          typeId = this.intervention['typeDebrief'][i]['id'];
        }
      }
      if (this.audit) {
        typeId = 45;
        if (this.intervention.typeId === 20) {
          typeId = 51;
        }
      }
      if (this.intervention.typeId === 15 || this.intervention.typeId === 16) {
        typeId = 48;
      }
      if (this.auditconstatation) {
        typeId = 50;
      }
      if (!typeId) {
        this.start = false;
        return this.$toast.bottom('Une erreur est survenue lors de la récuperation du debrief 1/2');
      }
      var _this = this;
      this.$http.get('recap/' + typeId).then(function (response) {
        _this4.response = response.json().then(function (data) {
          localStorage.setItem('debrief_' + _this4.intervention_id, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
          if (_this4.auditinfra && !_this4.auditconstatation) {
            _this.$getItem(_this4.intervention_id, function (err, values) {
              if (err) {
                return;
              }
              if (!values.pm || !values.pm.length) {
                _this.$http.get('intervention/' + _this.intervention_id + '/pm').then(function (response) {
                  if (!response.body.length) {
                    _this.$toast.bottom('Aucune position n\'a été trouvée sur ce PM');
                  }
                  values.pm = response.body;
                  values.pm.forEach(function (pm) {
                    pm.complete = false;
                  });
                  _this.$setItem(_this.intervention_id, values, function (err, value) {
                    if (err) {
                      alert(err);
                    }
                    _this.$router.push('/intervention/' + _this.intervention_id + '/auditpm');
                  });
                });
              } else {
                _this.$router.push('/intervention/' + _this.intervention_id + '/auditpm');
              }
            });
          } else if (_this4.auditconstatation) _this.$router.push('/intervention/' + _this.intervention_id + '/auditconstatation');else _this.$router.push('/intervention/' + _this.intervention_id + '/debrief');
          _this4.start = false;
        });
      }, function (response) {
        _this4.start = false;
        _this4.$toast.bottom('Une erreur est survenue lors de la récuperation du debrief 2/2');
      });
    },
    getEtatBox: function getEtatBox(callback) {
      var _this5 = this;

      this.checkBox = true;
      var data = {};
      data.pto = this.intervention.cmdAcces.ptoNom;
      data.intervention_id = this.intervention.interventionId;
      this.$http.get('intervention/' + data.intervention_id + '/etatbox', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        _this5.response = response.json().then(function (data) {
          if (data.etat_box) {
            _this5.intervention.etat = 'OK';
          } else {
            _this5.intervention.etat = 'NOK';
          }
          _this5.saveToCache();
          if (callback !== undefined) {
            callback();
          }
          _this5.checkBox = false;
        });
      }, function (response) {
        if (response.status === 429) {
          _this5.$toast.bottom(response.body.message);
        } else {
          _this5.$toast.bottom('Une erreur est survenue lors du ping de la box');
        }
        _this5.checkBox = false;
      });
    },
    isNotEmpty: function isNotEmpty(intervention) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(intervention).length === 0 ? 0 : 1;
    },
    isNotHoline: function isNotHoline(pto) {
      return pto.cmdAcces.ptoNom === 'Reprov obligatoire' ? 0 : 1;
    },
    startIntervention: function startIntervention() {
      var _this6 = this;

      this.start = true;
      this.$http.get('intervention/' + this.intervention_id + '/action/start').then(function (response) {
        if (response.status === 202) {
          _this6.$toast.bottom(response.body.message);
        }
        _this6.response = response.json().then(function (data) {
          _this6.intervention.dateDebut = data.dateDebut;
          _this6.saveToCache(_this6.intervention_id, _this6.intervention);
          _this6.start = false;
        });
      }, function (response) {
        _this6.start = false;
      });
    },
    diffDate: function diffDate(intervention) {
      var bdate = new Date();
      if (intervention.dateFin !== null) {
        bdate = intervention.dateFin;
      }
      var a = __WEBPACK_IMPORTED_MODULE_3_moment___default()(bdate);
      var b = __WEBPACK_IMPORTED_MODULE_3_moment___default()(intervention.dateDebut);
      var diff = a.diff(b);
      var duration = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(diff);

      if (duration.days() !== 0) {
        return 'Durée : ' + duration.days() + 'j ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's';
      }

      return 'Durée : ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's';
    },
    goBackIntervention: function goBackIntervention() {
      this.$router.go(-1);
    },
    getData: function getData(key, value) {
      if (this.intervention[key] !== undefined) {
        if (this.intervention[key][value] !== undefined) {
          return this.intervention[key][value];
        }
      }
    },
    getRop: function getRop(intervention) {
      var html = '';

      if (intervention.cmdAcces === undefined) {
        return '';
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(intervention.cmdAcces).length === 0) {
        return '';
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(intervention.cmdAcces['ropData']).length === 0) {
        return '';
      }
      html += '<div style="font-size: 16px; margin-bottom: 5px; border-bottom: 0.5px solid #666"><b><i class="fa fa-building-o" aria-hidden="true"></i> Verticalité</b></div>';
      for (var i in intervention.cmdAcces['ropData']['verticalite']['common']) {
        html += '<div style="font-size: 13px;"><b>' + i + ' : </b>' + intervention.cmdAcces['ropData']['verticalite']['common'][i] + '</div>';
      }
      html += '<div style="padding: 10px">';
      for (var _i = 1; _i <= 4; _i++) {
        if (intervention.cmdAcces['ropData']['verticalite']['fibre' + _i] === undefined) {
          continue;
        }

        if (intervention.cmdAcces['ropData']['verticalite']['fibre' + _i]['fibreOperateur'] === 'FREE') {
          html += '<div style="font-size: 14px; margin-bottom: 5px;margin-top: 5px;color:rgb(230, 68, 68); "><b> <i class="fa fa-chevron-right" aria-hidden="true"></i> Fibre ' + _i + ' - FREE</b></div>';
        } else {
          html += '<div style="font-size: 14px; margin-bottom: 5px;margin-top: 5px;"><b> <i class="fa fa-chevron-right" aria-hidden="true"></i> Fibre ' + _i + '</b></div>';
        }
        delete intervention.cmdAcces['ropData']['verticalite']['fibre' + _i]['fibreOperateur'];

        for (var key in intervention.cmdAcces['ropData']['verticalite']['fibre' + _i]) {
          html += '<div style="font-size: 13px;"><b>' + key + ' : </b>' + intervention.cmdAcces['ropData']['verticalite']['fibre' + _i][key] + '</div>';
        }
      }
      html += '</div>';

      html += '<div style="font-size: 16px; margin-bottom: 5px; border-bottom: 0.5px solid #666"><b><i class="fa fa-road" aria-hidden="true"></i> Horizontalité</b></div>';
      for (var _i2 in intervention.cmdAcces['ropData']['horizontalite']) {
        var label = null;
        if (_i2 === 'backbone') {
          label = 'Backbone';
        }
        if (_i2 === 'connecteurCad') {
          label = 'Connecteur CAD';
        }
        if (_i2 === 'positionBaie') {
          label = 'Position baie';
        }
        if (_i2 === 'breakout') {
          label = 'Breakout';
        }
        if (_i2 === 'baieActive') {
          label = 'Baie active';
        }

        html += '<div style="font-size: 13px;"><b>' + label + ' : </b>' + intervention.cmdAcces['ropData']['horizontalite'][_i2] + '</div>';
      }
      return html;
    },
    saveToCache: function saveToCache() {
      this.$setItem(this.intervention_id, this.intervention, function (err, values) {
        if (err) {
          alert(err);
        }
      });
    },
    sync: function sync() {
      this.getIntervention();
    },
    getIntervention: function getIntervention(cb) {
      var _this7 = this;

      this.$http.get('intervention/' + this.intervention_id).then(function (response) {
        _this7.response = response.json().then(function (data) {
          _this7.intervention = data;
          _this7.cache = false;
          _this7.saveToCache();
          _this7.backLabel = 'Production';
          if (data.typeId === 2 || data.typeId === 4) {
            _this7.backLabel = 'PostProduction / SAV';
          }
          if (_this7.intervention.userAudit) {
            _this7.audit = true;
          }
          if (data.typeId === 15 || data.typeId === 16 || data.typeId === 18) {
            _this7.auditinfra = true;
          }
          if (data.typeId === 18) {
            _this7.auditconstatation = true;
          }
          if (typeof cb === 'function') {
            cb();
          }
        });
      }, function (response) {
        if (typeof cb === 'function') {
          cb();
        }
        if (!_this7.cache) {
          _this7.$toast.bottom('Une erreur est survenue lors de la récupération');
          _this7.messageLoading = '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Récupération impossible';
        }
      });
    }
  },
  mounted: function mounted() {
    this.intervention_id = this.$route.params.intervention_id;
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_2__assets_js_pulltorefresh__["a" /* default */].init({
      mainElement: '.intervention-content',
      onRefresh: function onRefresh(cb) {
        _this.getIntervention(cb);
      }
    });
    this.$getItem(this.intervention_id, function (err, values) {
      if (err) {
        return;
      }
      if (values === null) {
        _this.getIntervention();
        return;
      }

      _this.cache = true;
      _this.intervention = values;
      if (_this.intervention.userAudit) {
        _this.audit = true;
      }
      if (_this.intervention.typeId === 15 || _this.intervention.typeId === 16 || _this.intervention.typeId === 18) {
        _this.auditinfra = true;
      }
      if (_this.intervention.typeId === 18) {
        _this.auditconstatation = true;
      }
    });
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "nHb0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nqTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* eslint-disable */
var PullToRefresh = function () {
  var _ptrMarkup = function _ptrMarkup() {
    return "<div class=\"__PREFIX__box\"><div class=\"__PREFIX__content\"><div class=\"__PREFIX__icon\"></div><div class=\"__PREFIX__text\"></div></div></div>";
  };

  var _ptrStyles = function _ptrStyles() {
    return ".__PREFIX__ptr {\n  box-shadow: inset 0 -3px 5px rgba(0, 0, 0, 0.12);\n  pointer-events: none;\n  font-size: 0.85em;\n  font-weight: bold;\n  top: 0;\n  height: 0;\n  transition: height 0.3s, min-height 0.3s;\n  text-align: center;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-end;\n  align-content: stretch;\n}\n.__PREFIX__box {\n  padding: 10px;\n  flex-basis: 100%;\n}\n.__PREFIX__pull {\n  transition: none;\n}\n.__PREFIX__text {\n  margin-top: .33em;\n  color: rgba(0, 0, 0, 0.3);\n}\n.__PREFIX__icon {\n  color: rgba(0, 0, 0, 0.3);\n  transition: transform .3s;\n}\n.__PREFIX__top {\n  touch-action: pan-x pan-down pinch-zoom;\n}\n.__PREFIX__release .__PREFIX__icon {\n  transform: rotate(180deg);\n}\n";
  };

  /* eslint-disable import/no-unresolved */

  var _SETTINGS = {};

  var _defaults = {
    distThreshold: 60,
    distMax: 80,
    distReload: 60,
    bodyOffset: 30,
    mainElement: 'body',
    triggerElement: 'body',
    ptrElement: '.ptr',
    classPrefix: 'ptr--',
    cssProp: 'min-height',
    iconArrow: '&#8675;',
    iconRefreshing: '<i class="fa fa-refresh fa-spin"></i>',
    instructionsPullToRefresh: 'Tirez pour rafraîchir',
    instructionsReleaseToRefresh: 'Relâcher pour rafraîchir',
    instructionsRefreshing: 'Récupération des données',
    refreshTimeout: 1000,
    getMarkup: _ptrMarkup,
    getStyles: _ptrStyles,
    onInit: function onInit() {},
    onRefresh: function onRefresh() {
      return location.reload();
    },
    resistanceFunction: function resistanceFunction(t) {
      return Math.min(1, t / 2.5);
    },
    shouldPullToRefresh: function shouldPullToRefresh() {
      return !window.scrollY;
    }
  };

  var pullStartY = null;
  var pullMoveY = null;
  var dist = 0;
  var distResisted = 0;

  var _state = 'pending';
  var _setup = false;
  var _enable = false;
  var _timeout;

  var supportsPassive = false;

  try {
    window.addEventListener('test', null, {
      get passive() {
        supportsPassive = true;
      }
    });
  } catch (e) {
    // do nothing
  }

  function _update() {
    var classPrefix = _SETTINGS.classPrefix;
    var ptrElement = _SETTINGS.ptrElement;
    var iconArrow = _SETTINGS.iconArrow;
    var iconRefreshing = _SETTINGS.iconRefreshing;
    var instructionsRefreshing = _SETTINGS.instructionsRefreshing;
    var instructionsPullToRefresh = _SETTINGS.instructionsPullToRefresh;
    var instructionsReleaseToRefresh = _SETTINGS.instructionsReleaseToRefresh;

    var iconEl = ptrElement.querySelector("." + classPrefix + "icon");
    var textEl = ptrElement.querySelector("." + classPrefix + "text");

    if (_state === 'refreshing') {
      iconEl.innerHTML = iconRefreshing;
    } else {
      iconEl.innerHTML = iconArrow;
    }

    if (_state === 'releasing') {
      textEl.innerHTML = instructionsReleaseToRefresh;
    }

    if (_state === 'pulling' || _state === 'pending') {
      textEl.innerHTML = instructionsPullToRefresh;
    }

    if (_state === 'refreshing') {
      textEl.innerHTML = instructionsRefreshing;
    }
  }

  function _setupEvents() {
    function onReset() {
      var cssProp = _SETTINGS.cssProp;
      var ptrElement = _SETTINGS.ptrElement;
      var classPrefix = _SETTINGS.classPrefix;

      ptrElement.classList.remove(classPrefix + "refresh");
      ptrElement.style[cssProp] = '0px';

      _state = 'pending';
    }

    function _onTouchStart(e) {
      var shouldPullToRefresh = _SETTINGS.shouldPullToRefresh;
      var triggerElement = _SETTINGS.triggerElement;

      if (shouldPullToRefresh()) {
        pullStartY = e.touches[0].screenY;
      }

      if (_state !== 'pending') {
        return;
      }

      clearTimeout(_timeout);

      _enable = triggerElement.contains(e.target);
      _state = 'pending';
      _update();
    }

    function _onTouchMove(e) {
      var cssProp = _SETTINGS.cssProp;
      var classPrefix = _SETTINGS.classPrefix;
      var distMax = _SETTINGS.distMax;
      var distThreshold = _SETTINGS.distThreshold;
      var ptrElement = _SETTINGS.ptrElement;
      var resistanceFunction = _SETTINGS.resistanceFunction;
      var shouldPullToRefresh = _SETTINGS.shouldPullToRefresh;

      if (!pullStartY) {
        if (shouldPullToRefresh()) {
          pullStartY = e.touches[0].screenY;
        }
      } else {
        pullMoveY = e.touches[0].screenY;
      }

      if (!_enable || _state === 'refreshing') {
        if (shouldPullToRefresh() && pullStartY < pullMoveY) {
          e.preventDefault();
        }

        return;
      }

      if (_state === 'pending') {
        ptrElement.classList.add(classPrefix + "pull");
        _state = 'pulling';
        _update();
      }

      if (pullStartY && pullMoveY) {
        dist = pullMoveY - pullStartY;
      }

      if (dist > 0) {
        e.preventDefault();

        ptrElement.style[cssProp] = distResisted + "px";

        distResisted = resistanceFunction(dist / distThreshold) * Math.min(distMax, dist);

        if (_state === 'pulling' && distResisted > distThreshold) {
          ptrElement.classList.add(classPrefix + "release");
          _state = 'releasing';
          _update();
        }

        if (_state === 'releasing' && distResisted < distThreshold) {
          ptrElement.classList.remove(classPrefix + "release");
          _state = 'pulling';
          _update();
        }
      }
    }

    function _onTouchEnd() {
      var ptrElement = _SETTINGS.ptrElement;
      var onRefresh = _SETTINGS.onRefresh;
      var refreshTimeout = _SETTINGS.refreshTimeout;
      var distThreshold = _SETTINGS.distThreshold;
      var distReload = _SETTINGS.distReload;
      var cssProp = _SETTINGS.cssProp;
      var classPrefix = _SETTINGS.classPrefix;

      if (_state === 'releasing' && distResisted > distThreshold) {
        _state = 'refreshing';

        ptrElement.style[cssProp] = distReload + "px";
        ptrElement.classList.add(classPrefix + "refresh");

        _timeout = setTimeout(function () {
          var retval = onRefresh(onReset);

          if (retval && typeof retval.then === 'function') {
            retval.then(function () {
              return onReset();
            });
          }

          if (!retval && !onRefresh.length) {
            onReset();
          }
        }, refreshTimeout);
      } else {
        if (_state === 'refreshing') {
          return;
        }

        ptrElement.style[cssProp] = '0px';

        _state = 'pending';
      }

      _update();

      ptrElement.classList.remove(classPrefix + "release");
      ptrElement.classList.remove(classPrefix + "pull");

      pullStartY = pullMoveY = null;
      dist = distResisted = 0;
    }

    function _onScroll() {
      var mainElement = _SETTINGS.mainElement;
      var classPrefix = _SETTINGS.classPrefix;
      var shouldPullToRefresh = _SETTINGS.shouldPullToRefresh;

      mainElement.classList.toggle(classPrefix + "top", shouldPullToRefresh());
    }

    window.addEventListener('touchend', _onTouchEnd);
    window.addEventListener('touchstart', _onTouchStart);
    window.addEventListener('touchmove', _onTouchMove, supportsPassive ? { passive: _SETTINGS.passive || false } : undefined);

    window.addEventListener('scroll', _onScroll);

    // Store event handlers to use for teardown later
    return {
      onTouchStart: _onTouchStart,
      onTouchMove: _onTouchMove,
      onTouchEnd: _onTouchEnd,
      onScroll: _onScroll
    };
  }

  function _run() {
    var mainElement = _SETTINGS.mainElement;
    var getMarkup = _SETTINGS.getMarkup;
    var getStyles = _SETTINGS.getStyles;
    var classPrefix = _SETTINGS.classPrefix;
    var onInit = _SETTINGS.onInit;

    if (!document.querySelector("." + classPrefix + "ptr")) {
      var ptr = document.createElement('div');

      if (mainElement !== document.body) {
        mainElement.parentNode.insertBefore(ptr, mainElement);
      } else {
        document.body.insertBefore(ptr, document.body.firstChild);
      }

      ptr.classList.add(classPrefix + "ptr");
      ptr.innerHTML = getMarkup().replace(/__PREFIX__/g, classPrefix);

      _SETTINGS.ptrElement = ptr;
    }

    // Add the css styles to the style node, and then
    // insert it into the dom
    // ========================================================
    var styleEl;
    if (!document.querySelector('#pull-to-refresh-js-style')) {
      styleEl = document.createElement('style');
      styleEl.setAttribute('id', 'pull-to-refresh-js-style');

      document.head.appendChild(styleEl);
    } else {
      styleEl = document.querySelector('#pull-to-refresh-js-style');
    }

    styleEl.textContent = getStyles().replace(/__PREFIX__/g, classPrefix).replace(/\s+/g, ' ');

    if (typeof onInit === 'function') {
      onInit(_SETTINGS);
    }

    return {
      styleNode: styleEl,
      ptrElement: _SETTINGS.ptrElement
    };
  }

  var pulltorefresh = {
    init: function init(options) {
      if (options === void 0) options = {};

      var handlers;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_defaults).forEach(function (key) {
        _SETTINGS[key] = options[key] || _defaults[key];
      });

      var methods = ['mainElement', 'ptrElement', 'triggerElement'];
      methods.forEach(function (method) {
        if (typeof _SETTINGS[method] === 'string') {
          _SETTINGS[method] = document.querySelector(_SETTINGS[method]);
        }
      });

      if (!_setup) {
        handlers = _setupEvents();
        _setup = true;
      }

      var ref = _run();
      var styleNode = ref.styleNode;
      var ptrElement = ref.ptrElement;

      return {
        destroy: function destroy() {
          // Teardown event listeners
          window.removeEventListener('touchstart', handlers.onTouchStart);
          window.removeEventListener('touchend', handlers.onTouchEnd);
          window.removeEventListener('touchmove', handlers.onTouchMove, supportsPassive ? { passive: _SETTINGS.passive || false } : undefined);
          window.removeEventListener('scroll', handlers.onScroll);

          // Remove ptr element and style tag
          styleNode.parentNode.removeChild(styleNode);
          ptrElement.parentNode.removeChild(ptrElement);

          // Enable setupEvents to run again
          _setup = false;

          // null object references
          handlers = null;
          styleNode = null;
          ptrElement = null;
          _SETTINGS = {};
        }
      };
    }
  };

  return pulltorefresh;
}();

/* harmony default export */ __webpack_exports__["a"] = (PullToRefresh);

/***/ }),

/***/ "pHOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accueil_vue__ = __webpack_require__("+333");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9495532_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Accueil_vue__ = __webpack_require__("ZHzv");
function injectStyle (ssrContext) {
  __webpack_require__("BEw8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9495532"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accueil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9495532_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Accueil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pqyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.upload)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"label"},[_c('i',{staticClass:"fa fa-cog fa-spin fa-3x fa-fw"}),_vm._v(" "),_c('br'),_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"header-intervention"},[(_vm.intervention.pm !== undefined && _vm.start)?_c('div',{staticClass:"header-info"},[_vm._v(_vm._s(_vm.index + 1))]):_vm._e(),_vm._v(" "),(_vm.intervention.pm !== undefined)?_c('div',{staticClass:"button-content"},[(_vm.photoBefore)?_c('b-button',{staticClass:"button",on:{"click":_vm.startDebrief}},[_c('i',{staticClass:"fa fa-pencil-square-o"}),_vm._v(" Continuer\n      ")]):_vm._e(),_vm._v(" "),(_vm.index > 0 && (_vm.start || _vm.finalized))?_c('b-button',{staticClass:"button",on:{"click":_vm.previousPosition}},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Précédent\n      ")]):_vm._e(),_vm._v(" "),(_vm.showNextButton && _vm.start)?_c('b-button',{staticClass:"button",attrs:{"disabled":!_vm.isFormValid},on:{"click":function($event){_vm.nextPosition()}}},[_vm._v("Suivant "),_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),((_vm.index >= (_vm.positionsWithTech.length - 1) && (_vm.index <= _vm.positionsWithTech.length + _vm.positionsWithoutTech.length - 1)) && _vm.start)?_c('b-button',{staticClass:"button",attrs:{"disabled":_vm.intervention.pm.some(function (pos) { return pos.selected && !pos.complete; })},on:{"click":function($event){_vm.openConfirmModal()}}},[_vm._v("\n        Clôturer\n        "),_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.photoAfter)?_c('b-button',{staticClass:"button",on:{"click":_vm.end}},[_c('div',{staticClass:"fa fa-paper-plane"}),_vm._v("Envoyer\n      ")]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('b-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.photoBefore || _vm.photoAfter),expression:"photoBefore || photoAfter"}],staticClass:"photo-content"},[_c('div',{staticClass:"photo"},[(_vm.intervention.files !== undefined && _vm.intervention.files.length === 0)?_c('div',{staticClass:"photo-placeholder"},[_vm._v("Ajouter une photo du PM avant intervention")]):_vm._e(),_vm._v(" "),_vm._l((_vm.intervention.files),function(file,index){return _c('div',{key:index,staticClass:"picture"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(file.description))]),_vm._v(" "),_c('img',{staticClass:"preview",attrs:{"src":file.image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"options"},[_c('div',{staticClass:"rename",on:{"click":function($event){_vm.rename(file)}}},[_vm._v("Renommer")]),_vm._v(" "),_c('div',{staticClass:"delete",on:{"click":function($event){_vm.deleteFile(file)}}},[_vm._v("Supprimer")])])])}),_vm._v(" "),_c('div',{staticClass:"buttonPhoto",on:{"click":_vm.selectPicture}},[_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}}),_vm._v(" Ajouter des photos\n      ")]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","accept":"image/*","multiple":""},on:{"change":_vm.onFileChange}})],2)]),_vm._v(" "),_c('b-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.start),expression:"start"}],staticClass:"debrief-content"},[_c('div',{staticStyle:{"margin-bottom":"2rem"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","margin-bottom":"1rem"}},[(_vm.isCurrentPositionWithoutTech)?_c('b-button',{staticClass:"button",on:{"click":function($event){_vm.cancelNewPosition()}}},[_vm._v("\n          Annuler\n        ")]):_vm._e(),_vm._v(" "),(_vm.positionsWithoutTech.length && _vm.start && _vm.positionsWithoutTech.some(function (pos) { return !pos.item.selected; }) && _vm.index >= _vm.positionsWithTech.length - 1)?_c('b-button',{staticClass:"button",staticStyle:{"margin-left":"auto"},attrs:{"disabled":!_vm.isFormValid || _vm.positionsWithoutTech.some(function (pos) { return pos.item.selected && !pos.item.complete; })},on:{"click":_vm.showNewPositions}},[_vm._v("\n          Ajouter\n        ")]):_vm._e()],1),_vm._v(" "),_c('div',[_c('b',[_vm._v("Positions obligatoires: ")]),_vm._v(_vm._s(_vm.positionsWithTech.length))]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Positions optionnelles: ")]),_vm._v(" "+_vm._s(_vm.positionsWithoutTech.length))]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Positions traitées: ")]),_vm._v(" "+_vm._s(_vm.intervention.pm !== undefined && _vm.intervention.pm.filter(function (pos) { return pos.complete; }).length))]),_vm._v(" "),_c('hr',{staticClass:"divider"})]),_vm._v(" "),(_vm.intervention.pm !== undefined && _vm.intervention.pm[_vm.index] !== undefined)?_c('div',[_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("OC : ")]),_vm._v(" "+_vm._s(_vm.intervention.pm[_vm.index].rop.fo.oc1.oc))]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("OI : ")]),_vm._v(" "+_vm._s(_vm.intervention.pm[_vm.index].operateur))]),_vm._v(" "),(_vm.intervention.pm[_vm.index].oc !== undefined)?_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Connecteur opérateur tier (porte gauche): ")]),_vm._v(" "+_vm._s(((_vm.intervention.pm[_vm.index].oc.nom_module_pm) + " " + (_vm.intervention.pm[_vm.index].oc.position_module_pm))))]):_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Connecteur opérateur tier (porte gauche): ")]),_vm._v("Non défini")]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Position coupleur FREE (porte gauche): ")]),_vm._v(" "+_vm._s(!_vm.intervention.pm[_vm.index].adduction || !_vm.intervention.pm[_vm.index].adduction.pm.position_coupleur ? 'Non défini' : _vm.intervention.pm[_vm.index].adduction.pm.position_coupleur))]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Coupleur optique : ")]),_vm._v(" "+_vm._s(!_vm.intervention.pm[_vm.index].adduction || !_vm.intervention.pm[_vm.index].adduction.pm.coupleur ? 'Non défini' : _vm.intervention.pm[_vm.index].adduction.pm.coupleur))]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Fibre backbone : ")]),_vm._v(" "+_vm._s(((_vm.intervention.pm[_vm.index].adduction.cable.nom) + " tube " + (_vm.intervention.pm[_vm.index].adduction.cable.couleur_tube) + " bague(s) " + (_vm.intervention.pm[_vm.index].adduction.cable.bague_tube) + " fibre " + (_vm.intervention.pm[_vm.index].adduction.cable.couleur_fibre))))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-arbre"},_vm._l((_vm.debrief),function(question,questionKey){return _c('div',{key:questionKey,staticClass:"content debrief"},[_c('div',{staticClass:"question",attrs:{"data-required":question.required,"data-question-id":question.question_id}},[_c('div',{staticClass:"label"},[_vm._v("\n            "+_vm._s(question.question_label)+"\n            "),(question.required)?_c('div',{staticClass:"required"},[_vm._v("( Réponse obligatoire )")]):_vm._e()]),_vm._v(" "),_vm._l((question.reponse),function(response,responseKey){return _c('div',{key:responseKey},[_c('div',{staticClass:"reponse-button action",class:{ check: _vm.isChecked(question.question_id, response.reponse_id) },attrs:{"data-question-id":question.question_id,"data-reponse-id":response.reponse_id},on:{"click":function($event){_vm.handleResponseClick(question.question_id, response.reponse_id)}}},[_c('i',{staticClass:"fa fa-check",class:{ hide: !_vm.isChecked(question.question_id, response.reponse_id) },attrs:{"aria-hidden":"true"}}),_vm._v("\n              "+_vm._s(response.reponse_label)+"\n            ")]),_vm._v(" "),(response.next_question)?_c('div',{staticClass:"child",class:['next_question_' + response.reponse_id, { hide: !_vm.isChecked(question.question_id, response.reponse_id) }]},[_c('ArbreRecursive',{attrs:{"debrief":_vm.debrief,"question":question,"response":response,"data":response.next_question,"index":_vm.index,"intervention":_vm.intervention,"requiredResponses":_vm.requiredResponses}})],1):_vm._e()])}),_vm._v(" "),(question.custom_response)?_c('div',{staticClass:"reponse-input",attrs:{"data-question-id":question.question_id}},[_c('input',{attrs:{"type":"text","placeholder":"Votre réponse"},on:{"input":function($event){_vm.updateCustomResponse(question.question_id, $event.target.value)}}})]):_vm._e()],2)])})),_vm._v(" "),_c('div',{staticClass:"bulle",on:{"click":_vm.stopAudit}},[_c('i',{staticClass:"fa fa-stop"})])]),_vm._v(" "),_c('modal',{staticClass:"new-positions",attrs:{"name":"new-positions","height":"auto","width":_vm.modalWidth,"resizable":true,"scrollable":true}},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Positions")]),_vm._v(" "),_c('i',{staticClass:"fa fa-times",on:{"click":_vm.closingModal}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},_vm._l((_vm.positionsWithoutTech),function(position,i){return _c('div',{key:i},[(!position.item.selected)?_c('div',{staticStyle:{"margin-bottom":"2rem"}},[_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("OC : ")]),_vm._v(" "+_vm._s(position.item.rop.fo.oc1.oc))]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("OI : ")]),_vm._v(" "+_vm._s(position.item.operateur))]),_vm._v(" "),(position.oc !== undefined)?_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Connecteur opérateur tier (porte gauche): ")]),_vm._v(" "+_vm._s(((position.item.oc.nom_module_pm) + " " + (position.item.oc.position_module_pm))))]):_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Connecteur opérateur tier (porte gauche): ")]),_vm._v("Non défini")]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Position coupleur FREE (porte gauche): ")]),_vm._v(" "+_vm._s(!position.item.adduction || !position.item.adduction.pm.position_coupleur ? 'Non défini' : position.item.adduction.pm.position_coupleur))]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Coupleur optique : ")]),_vm._v(" "+_vm._s(!position.item.adduction || !position.item.adduction.pm.coupleur ? 'Non défini' : position.item.adduction.pm.coupleur))]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span',{staticClass:"label"},[_vm._v("Fibre backbone : ")]),_vm._v(" "+_vm._s(((position.item.adduction.cable.nom) + " tube " + (position.item.adduction.cable.couleur_tube) + " bague(s) " + (position.item.adduction.cable.bague_tube) + " fibre " + (position.item.adduction.cable.couleur_fibre))))]),_vm._v(" "),(_vm.start)?_c('b-button',{staticClass:"button",on:{"click":function($event){_vm.nextPosition(position.index)}}},[_vm._v("Sélectionner")]):_vm._e(),_vm._v(" "),(_vm.positionsWithoutTech.length - 1 > i || _vm.positionsWithoutTech.some(function (pos) { return pos.item.selected; }).length > 1)?_c('hr',{staticClass:"divider"}):_vm._e()],1):_vm._e()])}))]),_vm._v(" "),_c('modal',{attrs:{"name":"confirmation","height":"auto","width":_vm.modalWidth}},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Attention")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Vous étes sur le point de valider le debriefing. Êtes-vous sur de vouloir terminer l'intervention?")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('b-button',{staticClass:"button",attrs:{"variant":"outline-danger"},on:{"click":function($event){_vm.$modal.hide('confirmation')}}},[_vm._v("Annuler")]),_vm._v(" "),_c('b-button',{staticClass:"button",attrs:{"variant":"danger"},on:{"click":_vm.finalize}},[_vm._v("Confirmer")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qDI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_pulltorefresh__ = __webpack_require__("nqTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__("abWm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('fr');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Account',
  data: function data() {
    return {
      account: {}
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('dddd DD MMMM à HH:MM');
    },
    goBackIntervention: function goBackIntervention() {
      this.$router.go(-1);
    },
    getAccount: function getAccount(cb) {
      var _this2 = this;

      this.$http.get('user').then(function (response) {
        _this2.response = response.json().then(function (data) {
          if (typeof cb === 'function') {
            cb();
          }
          _this2.account = data;
        });
      }, function (response) {
        if (typeof cb === 'function') {
          cb();
        }
        _this2.$toast.bottom('Une erreur est survenue lors de la récupération');
      });
    },
    token: function token() {
      if (localStorage.getItem('token') !== null) {
        var decoded = __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.decode(localStorage.getItem('token'));
        var exp = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(decoded.exp);
        var unix = Math.round(+new Date() / 1000);
        var now = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(unix);
        var test = exp.diff(now);
        var duration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(test);
        if (duration.days() !== 0) {
          return duration.days() + 'j ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's';
        }
        return duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's';
      }
    },
    logout: function logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('login');
      localStorage.removeItem('password');
      this.$router.push('/');
    }
  },
  mounted: function mounted() {
    this.getAccount();
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__assets_js_pulltorefresh__["a" /* default */].init({
      mainElement: '.account-content',
      onRefresh: function onRefresh(cb) {
        _this.getAccount(cb);
      }
    });
  }
});

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("X7DP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rrPM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tCYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ArbreRecursive',
  props: {
    debrief: Object,
    question: Object,
    response: Object,
    data: Object,
    intervention: Object,
    index: Number,
    requiredResponses: Array
  },
  methods: {
    isChecked: function isChecked(questionId, responseId) {
      if (!this.intervention.pm || !this.intervention.pm[this.index] || !this.intervention.pm[this.index].reponses) {
        return false;
      }

      return this.intervention.pm[this.index].reponses.some(function (r) {
        if (parseInt(r.question_id) === questionId && parseInt(r.reponse_id) === responseId) {
          return true;
        }
      });
    },
    handleResponseClick: function handleResponseClick(questionId, responseId) {
      var _this = this;

      var responses = this.intervention.pm[this.index].reponses || [];
      var existingResponseIndex = responses.findIndex(function (r) {
        return parseInt(r.question_id) === questionId;
      });

      if (existingResponseIndex !== -1) {
        this.$delete(responses, existingResponseIndex);
      }

      this.$set(responses, responses.length, { question_id: questionId, reponse_id: responseId });

      if (this.response.next_question) {
        var response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.response.next_question).find(function (r) {
          return r.question_id === questionId;
        });

        if (response) {
          var requiredResponseIndex = this.requiredResponses.findIndex(function (r) {
            return r.index === _this.question.question_id;
          });
          this.$set(this.requiredResponses, requiredResponseIndex, { index: questionId, answered: true });
        }
      }
      this.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "uK6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__("qDI4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd244c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__("WI0a");
function injectStyle (ssrContext) {
  __webpack_require__("ia2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fd244c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd244c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vJ5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scan_vue__ = __webpack_require__("as/e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9b6592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scan_vue__ = __webpack_require__("KMPp");
function injectStyle (ssrContext) {
  __webpack_require__("U+l5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a9b6592"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9b6592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vWbg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    if (localStorage.getItem('token') === null) {
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ "y8dM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Debrief__ = __webpack_require__("JmD1");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TestArbre',
  components: {
    Debrief: __WEBPACK_IMPORTED_MODULE_1__Debrief__["a" /* default */]
  },
  data: function data() {
    return {
      options: [],
      arbres: [],
      selectedArbre: 0,
      selected: false,
      loading: false,
      message: '',
      login: [5603, 3179, 4926, 11506, 4220, 445, 480, 10636, 15701]
    };
  },

  methods: {
    getArbre: function getArbre(event) {
      var _this = this;

      if (event === 0) {
        this.selected = false;
      } else {
        this.toggleLoader('Chargement de l\'arbre de débriefing en cours.');
        this.selected = false;
        this.$http.get('recap/' + event).then(function (response) {
          _this.response = response.json().then(function (data) {
            localStorage.setItem('debrief', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
            localStorage.setItem('arbre', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.arbres[event]));
            _this.toggleLoader('');
            _this.selected = true;
          });
        }, function () {
          _this.toggleLoader('');
          _this.$toast.bottom('Une erreur est survenue lors de la récupération du débriefing');
        });
      }
    },
    toggleLoader: function toggleLoader(message) {
      this.message = message;
      this.loading = !this.loading;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.toggleLoader('Téléchargement des arbres en cours');
    this.$http.get('arbre/testarbres').then(function (response) {
      response.json().then(function (result) {
        _this2.options.push({ value: 0, text: 'Choisissez un arbre' });
        var data = result.arbreTest;
        for (var i in data) {
          var beta = '';
          if (data[i].beta === 1 && _this2.login.indexOf(result.login) !== -1) {
            beta = ' (BETA) ';
          } else if (data[i].beta === 1 && _this2.login.indexOf(result.login) === -1) {
            continue;
          }
          _this2.options.push({
            value: data[i]['id_type_question'],
            text: data[i]['nom_type_intervention'] + beta + ' --- ' + data[i]['etat']
          });
          _this2.arbres[data[i]['id_type_question']] = { id: data[i]['id_type_intervention'], etat: data[i]['etat'] };
        }
        _this2.toggleLoader('');
      });
    }, function (err) {
      _this2.toggleLoader('');
      _this2.$toast.bottom('Une erreur est survenue lors de la récuperation des arbres de test');
      console.log(err);
    });
  }
});

/***/ }),

/***/ "yJkR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_signature_pad__ = __webpack_require__("kBR5");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'debrief',
  props: {
    isTest: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selected: '',
      type_photo: [],
      files: [],
      renameFile: null,
      intervention_id: null,
      debrief: {},
      signature: false,
      checked: false,
      reponse_count: 0,
      auditPhoto: false,
      signaturePad: null,
      intervention: {},
      debrief_data: null,
      audit: false,
      upload: false,
      message: '',
      waiting: {
        position: 0,
        total: 0
      },
      wrapper_class: 'debrief-content'
    };
  },

  methods: {
    showCountLabel: function showCountLabel(reponseCount) {
      if (reponseCount === 0) {
        return 'Débrief OK';
      }
      if (reponseCount > 1) {
        return reponseCount + ' questions restantes';
      }
      if (reponseCount === 1) {
        return reponseCount + ' question restante';
      }
    },
    reset: function reset() {
      this.signaturePad.clear();
    },
    back: function back() {
      if (!this.isTest) {
        this.$router.push('/intervention/' + this.intervention_id);
      } else {
        this.$parent.selectedArbre = 0;
        this.$parent.selected = false;
      }
    },
    getEtat: function getEtat(intervention) {
      var html = 'Etat box : ';
      if (intervention.etat === 'OK') {
        html += '<label style="font-size: 20px;color: green;">OK</label>';
      } else if (intervention.etat === 'NOK') {
        html += '<label style="font-size: 20px;color: red;">NOK</label>';
      } else {
        html += '<label style="font-size: 20px;color: orange;">-</label>';
      }
      return html;
    },
    signatureShow: function signatureShow() {
      if (this.audit) {
        this.auditPhoto = true;
      } else {
        if (this.auditPhoto) {
          this.signature = true;
          this.auditPhoto = false;
        }
        if (!this.signature) {
          this.auditPhoto = true;
        }
      }
      if (this.auditPhoto) {
        var send = [];
        $('.content > .question').each(function (index) {
          if ($(this).is(':visible')) {
            if ($(this).find('.reponse-button').hasClass('check')) {
              send.push({
                question_id: $(this).find('.reponse-button.check').data('question-id'),
                response_id: $(this).find('.reponse-button.check').data('reponse-id')
              });
            }
            if ($(this).find('.reponse-input > input').val() !== '' && $(this).find('.reponse-input > input').val() !== undefined) {
              send.push({
                question_id: $(this).find('.reponse-input').data('question-id'),
                response_id: null,
                response_text: $(this).find('.reponse-input > input').val()
              });
            }
          }
        });
        this.debrief_data = send;
      }
      window.scrollTo(0, 0);
    },
    getData: function getData(key, value) {
      if (this.intervention[key] !== undefined) {
        if (this.intervention[key][value] !== undefined) {
          return this.intervention[key][value];
        }
      }
    },
    selectPicture: function selectPicture() {
      this.$refs.fileInput.click();
    },
    uploadPicture: function uploadPicture() {
      if (this.waiting.position >= this.files.length) {
        this.upload = false;
        this.waiting.position = 0;
        this.waiting.total = 0;
        this.files.length = 0;
        return;
      }
      if (!this.isTest) {
        this.upload = true;
        this.waiting.total = this.files.length;
        this.message = 'Upload ' + this.waiting.position + '/' + this.waiting.total;
        this.uploadPictureServer(this.files[this.waiting.position]);
      } else {
        this.upload = true;
        this.waiting.total = this.files.length;
        this.message = 'Upload ' + this.waiting.position + '/' + this.waiting.total;
        this.waiting.position++;
        this.upload = false;
        this.$toast('L\'envoie de photo à été effectué avec succès');
      }
    },
    uploadPictureServer: function uploadPictureServer(data) {
      var _this2 = this;

      this.$http.post('intervention/' + this.intervention_id + '/photo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        _this2.response = response.json().then(function (data) {
          _this2.waiting.position++;
          _this2.uploadPicture();
        });
      }, function (response) {
        console.log(response);
      });
    },
    rename: function rename(file) {
      file.description = prompt('Nommer la photo', file.description);
    },
    renameSelector: function renameSelector(file) {
      var _this3 = this;

      this.renameFile = file;
      this.$http.get('typephoto').then(function (response) {
        _this3.response = response.json().then(function (data) {
          _this3.type_photo = data;
          _this3.start = false;
        });
      }, function (response) {
        _this3.start = false;
      });
      this.$modal.show('selector');
    },
    closModal: function closModal() {
      this.renameFile.description = this.selected;
      this.$modal.hide('selector');
    },
    deleteFile: function deleteFile(file) {
      var i = this.files.indexOf(file);
      if (i !== -1) {
        this.files.splice(i, 1);
      }
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      var _this = this;

      var _loop = function _loop(i) {
        var file = files[i];

        if (!(file instanceof File)) {
          return 'continue';
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            var maxWidth = 1024;
            var maxHeight = 768;
            var imageWidth = image.width;
            var imageHeight = image.height;

            if (imageWidth > imageHeight) {
              if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth;
                imageWidth = maxWidth;
              }
            } else {
              if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight;
                imageHeight = maxHeight;
              }
            }
            var canvas = document.createElement('canvas');
            canvas.width = imageWidth;
            canvas.height = imageHeight;
            image.width = imageWidth;
            image.height = imageHeight;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(this, 0, 0, imageWidth, imageHeight);
            _this.files.push({
              image: canvas.toDataURL(file.type).replace('jpeg', 'jpg').replace('png', 'jpg'),
              description: file.name.replace('.jpeg', '').replace('.jpg', '').replace('.png', '')
            });
          };
        };
        reader.readAsDataURL(file);
      };

      for (var i in files) {
        var _ret = _loop(i);

        if (_ret === 'continue') continue;
      }
    },
    signatureBack: function signatureBack() {
      if (this.signature) {
        this.auditPhoto = true;
        this.signature = false;
      } else {
        this.signature = false;
        this.auditPhoto = false;
      }
    },
    send: function send() {
      var _this4 = this;

      if (!this.isTest) {
        var data = {};
        data.debrief = this.debrief_data;
        if (this.signaturePad.isEmpty() && !this.audit) {
          this.$toast.bottom('La signature est vide');
          return;
        }
        data.signature = 'close';
        if (!this.signaturePad.isEmpty()) {
          data.signature = this.signaturePad.toDataURL('image/jpeg');
        }
        if (this.audit && this.files.length !== 0) {
          this.$toast.bottom('Merci de cliquer sur "Envoyer les photos" en bas de page');
          return;
        }
        this.$http.post('intervention/' + this.intervention_id + '/action/debrief', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          _this4.response = response.json().then(function (data) {
            _this4.start = false;
            _this4.$removeItem(_this4.intervention_id);
            _this4.$router.push('/intervention/' + _this4.intervention_id);
            _this4.$toast.bottom('Intervention terminée');
          });
        }, function (response) {
          _this4.start = false;
          if (response.status === 403) {
            _this4.$router.push('/intervention/' + _this4.intervention_id);
            _this4.$toast.bottom('Le debrief n\'a pas pu être debriefer car la date de rendez vous a été modifié !');
          }
          _this4.$toast.bottom('Une erreur est survenue lors de l\'envoi du debrief');
        });
      } else {
        this.back();
        this.$toast.bottom('Le test du debrief est maintenant terminé');
      }
    },
    count: function count() {
      var t = 0;
      $('.content > .question').each(function (index) {
        if ($(this).data('required')) {
          if ($(this).is(':visible')) {
            if ($(this).has('.reponse-button').length !== 0) {
              if ($(this).find('.reponse-button').not('.check').length === $(this).find('.reponse-button').length) {
                t++;
              }
            }
            if ($(this).find('.reponse-input > input').val() === '') {
              t++;
            }
          }
        }
      });
      this.reponse_count = t;
    },
    arbre: function arbre(debrief) {
      var html = '';
      for (var i in debrief) {
        var required = '';
        if (debrief[i]['required']) {
          required = '<div class="required">( Réponse obligatoire )</div>';
        }
        html += '<div class="content debrief"><div class="question" data-required="' + debrief[i]['required'] + '" data-question-id="' + debrief[i]['question_id'] + '"> <div class="label">' + debrief[i]['question_label'] + ' ' + required + '</div>';
        for (var b in debrief[i]['reponse']) {
          html += '<div class="reponse-button action" data-question-id="' + debrief[i]['question_id'] + '" data-reponse-id="' + debrief[i]['reponse'][b]['reponse_id'] + '"><i class="fa fa-check hide" aria-hidden="true"></i> ' + debrief[i]['reponse'][b]['reponse_label'] + '</div>';
        }
        if (debrief[i]['custom_response']) {
          html += '<div class="reponse-input" data-question-id="' + debrief[i]['question_id'] + '"><input type="text" placeholder="Votre réponse"/></div>';
        }
        html += '</div>';
        for (var _b in debrief[i]['reponse']) {
          if (debrief[i]['reponse'][_b]['next_question'] !== null) {
            html += '<div class="child next_question_' + debrief[i]['reponse'][_b]['reponse_id'] + '"> ' + this.recursive(debrief[i]['reponse'][_b]['next_question'], '') + '</div>';
          }
        }
        html += '</div>';
      }
      $('.content-arbre').append(html);
      var _this = this;
      $('.reponse-input > input').keyup(function () {
        _this.count();
      });
      $('.action').on('click', function () {
        // let id = $(this).data('reponse-id')
        $(this).parent().find('.action').each(function (index) {
          $(this).removeClass('check');
          $(this).find('.fa').addClass('hide');
        });
        $(this).parent().parent().find('.child').each(function (index) {
          $(this).children('.content').hide();
        });
        $(this).addClass('check');
        $(this).find('.fa').removeClass('hide');
        $(this).parent().parent().find('.child').children('.content').find('.condition').each(function (index) {
          var json = JSON.parse($(this).text());
          var ok = 0;
          var count = json.length === undefined ? 0 : json.length;
          for (var _i in json) {
            var id = json[_i]['reponse_id'];
            if (json[_i]['has_this_value'] === 0) {
              if (!$('[data-reponse-id="' + id + '"]').hasClass('check')) {
                ok++;
              }
            } else {
              if ($('[data-reponse-id="' + id + '"]').hasClass('check')) {
                ok++;
              }
            }
          }
          if (ok === count) {
            $(this).parent().show();
          }
        });

        _this.count();
      });

      this.count();
    },
    recursive: function recursive(data, html) {
      for (var i in data) {
        if (i === 'null') {
          continue;
        }

        var required = '';
        if (data[i]['required']) {
          required = '<div class="required">( Réponse obligatoire )</div>';
        }
        html += '<div class="content debrief sub hide"><div class="condition hide">' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data[i]['condition']) + '</div><div class="question" data-required="' + data[i]['required'] + '" data-question-id="' + data[i]['question_id'] + '"> <div class="label">' + data[i]['question_label'] + ' ' + required + '</div>';
        for (var b in data[i]['reponse']) {
          html += '<div class="reponse-button action" data-question-id="' + data[i]['question_id'] + '" data-reponse-id="' + data[i]['reponse'][b]['reponse_id'] + '"><i class="fa fa-check hide" aria-hidden="true"></i> ' + data[i]['reponse'][b]['reponse_label'] + '</div>';
        }
        if (data[i]['custom_response']) {
          html += '<div class="reponse-input" data-question-id="' + data[i]['question_id'] + '"><input type="text" placeholder="Votre réponse"/></div>';
        }
        html += '</div>';
        for (var _b2 in data[i]['reponse']) {
          if (data[i]['reponse'][_b2]['next_question'] !== null) {
            html += '<div class="child next_question_' + data[i]['reponse'][_b2]['reponse_id'] + '"> ' + this.recursive(data[i]['reponse'][_b2]['next_question'], '') + '</div>';
          }
        }
        html += '</div>';
      }
      return html;
    }
  },
  mounted: function mounted() {
    this.$modal.hide('selector');
    var _this = this;
    var data = void 0;
    if (!this.isTest) {
      this.intervention_id = this.$route.params.intervention_id;
      data = localStorage.getItem('debrief_' + this.intervention_id);

      this.$getItem(this.intervention_id, function (err, values) {
        if (!err) {
          _this.intervention = values;
          if (_this.intervention.userAudit || _this.intervention.typeId === 18) {
            _this.audit = true;
          }
        }
      });
    } else {
      this.wrapper_class = 'debrief-content-test';
      data = localStorage.getItem('debrief');
      var arbre = localStorage.getItem('arbre');
      arbre = JSON.parse(arbre);
      var values = {};
      values.rdvClient = false;
      values.typeId = arbre.id;
      values.etat = arbre.etat;
      _this.intervention = values;
      _this.intervention_id = 1231564;
    }
    if (data !== undefined) {
      this.debrief = JSON.parse(data);
      this.arbre(this.debrief);
    }
    var canvas = document.getElementById('signature-pad');
    this.signaturePad = new __WEBPACK_IMPORTED_MODULE_1_signature_pad__["a" /* default */](canvas, {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      penColor: 'rgb(0, 0, 0)'
    });
  }
});

/***/ }),

/***/ "yLHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interventions"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.start)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"label"},[_c('i',{staticClass:"fa fa-cog fa-spin fa-3x fa-fw"}),_vm._v(" "),_c('br'),_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]):_vm._e()]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"header-intervention"},[(!_vm.intervention.dateDebut)?_c('div',{staticClass:"header-info"},[_vm._v("\n      "+_vm._s(_vm.formatDate(_vm.intervention.dateRdv))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut)?_c('div',{staticClass:"header-info"},[_vm._v("\n      "+_vm._s(_vm.diffDate(_vm.intervention))+"\n    ")]):_vm._e(),_vm._v(" "),(!_vm.intervention.dateDebut && ([6, 15, 16, 18, 20].indexOf(_vm.intervention.typeId) !== -1))?_c('div',{staticClass:"button-content"},[_c('div',{staticClass:"button",on:{"click":function($event){_vm.startIntervention()}}},[_c('i',{staticClass:"fa fa-play",attrs:{"aria-hidden":"true"}}),_vm._v(" Démarrer\n      ")])]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut && !_vm.intervention.dateFin && ([6, 15, 16, 18, 20].indexOf(_vm.intervention.typeId) !== -1))?_c('div',{staticClass:"button-content"},[_c('div',{staticClass:"button",on:{"click":function($event){_vm.startDebrief()}}},[_c('i',{staticClass:"fa fa-pencil-square-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Débriefer\n      ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"header-intervention"},[_c('div',{staticClass:"header-loading",domProps:{"innerHTML":_vm._s(_vm.messageLoading)}})]):_vm._e(),_vm._v(" "),_c('b-container',{staticClass:"intervention-content"},[(([6, 15, 16, 18, 20].indexOf(_vm.intervention.typeId) === -1))?_c('b-alert',{staticClass:"cache",attrs:{"variant":"warning","show":""}},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_vm._v(" Le debriefing est uniquement accessible via la version android d'Aboracco."),_c('br'),_vm._v("Si vous rencontrez des difficultés, il faut contacter votre CA.")]):_vm._e(),_vm._v(" "),(_vm.cache)?_c('b-alert',{staticClass:"cache",attrs:{"variant":"warning","show":""}},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_vm._v(" Cache activé "),_c('br'),_vm._v(" Tirez pour synchroniser ou "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.sync}},[_vm._v("cliquez ici")])]):_vm._e(),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention) && !_vm.auditinfra && (_vm.intervention.dateDebut || _vm.audit))?_c('div',{staticClass:"etat-box"},[(!_vm.checkBox)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getEtat(_vm.intervention))}}):_vm._e(),_vm._v(" "),(_vm.checkBox)?_c('div',{staticStyle:{"font-size":"60px","color":"orange"}},[_c('i',{staticClass:"fa fa-cog fa-spin"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("ÉTAT BOX ( "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.getEtatBox()}}},[_vm._v("Rafraichir")]),_vm._v(" )")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"information"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-calendar-check-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("RDV")])])]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"content"},[_c('div',{staticClass:"label"},[_c('b',[_vm._v("Type : ")]),_vm._v(_vm._s(_vm.intervention.typeReference)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Description : ")]),_vm._v(_vm._s(_vm.intervention.descr)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Date du RDV : ")]),_vm._v(_vm._s(_vm.formatDate(_vm.intervention.dateRdv))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("RDV Client : ")]),_vm._v(" "),(_vm.intervention.rdvClient)?_c('i',{staticClass:"fa fa-check green-color",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.intervention.rdvClient)?_c('i',{staticClass:"fa fa-times red-color",attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),(!_vm.intervention.dateDebut && !_vm.audit)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("NRO : ")]),_vm._v(_vm._s(_vm.intervention.nro)+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.intervention.dateDebut && !_vm.audit)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("Adresse : ")]),_c('a',{attrs:{"href":""}},[_vm._v(_vm._s(_vm.getData('adresse','formePostal')))])]):_vm._e(),_vm._v(" "),(!_vm.intervention.dateDebut && !_vm.audit && !_vm.auditinfra)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("Abonné : ")]),_vm._v(_vm._s(_vm.getData('client','nom') !== null ? _vm.getData('client','nom') :  _vm.getData('cmdAcces','clientNom'))+" "+_vm._s(_vm.getData('client','prenom') !== null ? _vm.getData('client','prenom') :  _vm.getData('cmdAcces','clientPrenom'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.intervention.dateDebut && !_vm.audit && !_vm.auditinfra)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("Jeton : ")]),_vm._v(_vm._s(_vm.getData('cmdAcces','jeton'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.intervention.dateDebut && !_vm.audit && !_vm.auditinfra)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("Commentaire : ")]),_vm._v(_vm._s(_vm.intervention.commentaire)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut && _vm.auditinfra)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("NRO : ")]),_vm._v(_vm._s(_vm.intervention.nro)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut && _vm.auditinfra)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("PM : ")]),_vm._v(_vm._s(_vm.intervention.nomPm)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut && !_vm.auditinfra)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("ADSL fonctionnel : ")]),_vm._v(_vm._s(_vm.intervention.hasAdsl)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut && !_vm.auditinfra)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("Status client : ")]),_vm._v(_vm._s(_vm.intervention.statusClient)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("Début de l'intervention : ")]),_vm._v(_vm._s(_vm.formatDate(_vm.intervention.dateDebut))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.intervention.dateFin)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("Fin de l'intervention : ")]),_vm._v(_vm._s(_vm.formatDate(_vm.intervention.dateFin))+"\n        ")]):_vm._e()]):_c('div',{staticClass:"content"},[_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"})])]),_vm._v(" "),(_vm.audit)?_c('div',{staticClass:"information"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-user-md",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Technicien")])])]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"content"},[_c('div',{staticClass:"label"},[_c('b',[_vm._v("Nom : ")]),_vm._v(_vm._s(_vm.getData('userAudit','nom'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Prénom : ")]),_vm._v(_vm._s(_vm.getData('userAudit','prenom'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Entreprise : ")]),_vm._v(_vm._s(_vm.getData('userAudit','entreprise'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Numéro : ")]),_c('a',{attrs:{"href":'tel:' + _vm.getData('userAudit','numero')}},[_vm._v(_vm._s(_vm.getData('userAudit','numero')))])])]):_c('div',{staticClass:"content"},[_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"})])]):_vm._e(),_vm._v(" "),(!_vm.auditinfra && (_vm.intervention.dateDebut || _vm.audit))?_c('div',{staticClass:"information"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Client")])])]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"content"},[_c('div',{staticClass:"label"},[_c('b',[_vm._v("Nom : ")]),_vm._v(_vm._s(_vm.getData('client','nom') !== null ? _vm.getData('client','nom') :  _vm.getData('cmdAcces','clientNom'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Prénom : ")]),_vm._v(_vm._s(_vm.getData('client','prenom') !== null ? _vm.getData('client','prenom') :  _vm.getData('cmdAcces','clientPrenom'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Modèle BOX : ")]),_vm._v(_vm._s(_vm.getData('client','modelBox'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Adresse : ")]),_c('a',{attrs:{"href":""}},[_vm._v(_vm._s(_vm.getData('adresse','formePostal')))])]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Digicode : ")]),_vm._v(_vm._s(_vm.getData('client','digicode'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Résidence : ")]),_vm._v(_vm._s(_vm.getData('client','residence'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Batiment : ")]),_vm._v(_vm._s(_vm.getData('client','batiment') !== null ? _vm.getData('client','batiment') : _vm.getData('cmdAcces','batiment'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Etage : ")]),_vm._v(_vm._s(_vm.getData('client','etage'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Escalier : ")]),_vm._v(_vm._s(_vm.getData('client','escalier'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Porte : ")]),_vm._v(_vm._s(_vm.getData('client','porte'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Commentaire : ")]),_vm._v(_vm._s(_vm.intervention.commentaire)+"\n        ")])]):_c('div',{staticClass:"content"},[_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"})])]):_vm._e(),_vm._v(" "),(!_vm.auditinfra && (_vm.intervention.dateDebut || _vm.audit))?_c('div',{staticClass:"information"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-info",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Commande")])])]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"content"},[_c('div',{staticClass:"label"},[_c('b',[_vm._v("Jeton : ")]),_vm._v(_vm._s(_vm.getData('cmdAcces','jeton'))+"\n        ")]),_vm._v(" "),(!_vm.isNotHoline(_vm.intervention))?_c('div',{staticClass:"label"},[_c('b',[_vm._v("PTO à construire: ")]),_c('span',{staticStyle:{"font-size":"15px","color":"red"}},[_vm._v(_vm._s(_vm.getData('cmdAcces','ptoNom')))])]):_vm._e(),_vm._v(" "),(_vm.isNotHoline(_vm.intervention))?_c('div',{staticClass:"label"},[_c('b',[_vm._v("PTO à construire: ")]),_vm._v(_vm._s(_vm.getData('cmdAcces','ptoNom'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.intervention.cmdAcces.ptoCr)?_c('div',{staticClass:"label"},[_c('b',[_vm._v("Dernière PTO connue : ")]),_vm._v(_vm._s(_vm.getData('cmdAcces','ptoCr'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("PM : ")]),_vm._v(_vm._s(_vm.getData('cmdAcces','pm'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("NRO : ")]),_vm._v(_vm._s(_vm.intervention.nro)+"\n        ")])]):_c('div',{staticClass:"content"},[_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"})])]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut || _vm.audit)?_c('div',{staticClass:"information"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-building-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Information syndic")])])]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"content"},[_c('div',{staticClass:"label"},[_c('b',[_vm._v("Typologie : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','typologie'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Jarretierage : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','jarretierage'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Hébergement PM : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','typeHebergementPm'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Capa Max PM : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','capaMaxPm'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Type ingenierie : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','typeIngenierie'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Fibre dedié libre : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','fibreDedieeLibre'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Nombre colonnes : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','nombreColonnes'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Type matériel PM : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','typeMaterielPm'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Code immeuble : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','codeImmeuble'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Code acces immeuble : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','codeAccesImmeuble'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Contact immeuble : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','contactImmeuble'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Localisation PM : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','localisationPm'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("PM accessible : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','pmAccessible'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Info Clé : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','infoCle'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Code accès sous-sol : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','codeAccessSoussol'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Code local PM : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','codeLocalPm'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Autre : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','autre'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('b',[_vm._v("Contact syndic : ")]),_vm._v(_vm._s(_vm.getData('infosSyndic','contactSyndic'))+"\n        ")])]):_c('div',{staticClass:"content"},[_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"})])]):_vm._e(),_vm._v(" "),(!_vm.auditinfra && (_vm.intervention.dateDebut || _vm.audit))?_c('div',{staticClass:"information"},[_c('div',{staticClass:"header danger"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-road",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Route optique")])])]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention) || _vm.audit)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.getRop(_vm.intervention))}}):_c('div',{staticClass:"content"},[_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"})])]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut && !_vm.intervention.dateFin && !_vm.auditinfra)?_c('div',{staticClass:"information"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Kit Fibre")])])]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"content"},[(_vm.isNotHoline(_vm.intervention))?_c('div',{staticClass:"label center"},[_c('b',[_vm._v("Numéro série ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fibre),expression:"fibre"}],attrs:{"id":"fibre","type":"text"},domProps:{"value":(_vm.fibre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fibre=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"video_1"}}),_vm._v(" "),_c('div',{staticClass:"button",attrs:{"id":"scan_1"},on:{"click":function($event){_vm.scan(1)}}},[_c('i',{staticClass:"fa fa-barcode",attrs:{"aria-hidden":"true"}}),_vm._v(" Scan\n        ")]),_vm._v(" "),_c('div',{staticClass:"button hide",attrs:{"id":"closescan_1"},on:{"click":function($event){_vm.CloseScan(1)}}},[_c('i',{staticClass:"fa fa-barcode",attrs:{"aria-hidden":"true"}}),_vm._v(" Stop scan\n        ")]),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":_vm.pushKitFibre}},[_c('i',{staticClass:"fa fa-paper-plane-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Déclarer\n        ")])]):_c('div',{staticClass:"content"},[_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"})])]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut && !_vm.intervention.dateFin && !_vm.auditinfra)?_c('div',{staticClass:"information"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("Kit ONU")])])]),_vm._v(" "),(_vm.isNotEmpty(_vm.intervention))?_c('div',{staticClass:"content"},[(_vm.isNotHoline(_vm.intervention))?_c('div',{staticClass:"label center"},[_c('b',[_vm._v("Carton ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.onu.sn1),expression:"onu.sn1"}],attrs:{"id":"sn1","type":"text"},domProps:{"value":(_vm.onu.sn1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.onu, "sn1", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"video_2"}}),_vm._v(" "),_c('div',{staticClass:"button",attrs:{"id":"scan_2"},on:{"click":function($event){_vm.scan(2)}}},[_c('i',{staticClass:"fa fa-barcode",attrs:{"aria-hidden":"true"}}),_vm._v(" Scan\n        ")]),_vm._v(" "),_c('div',{staticClass:"button hide",attrs:{"id":"closescan_2"},on:{"click":function($event){_vm.CloseScan(2)}}},[_c('i',{staticClass:"fa fa-barcode",attrs:{"aria-hidden":"true"}}),_vm._v(" Stop scan\n        ")]),_vm._v(" "),(_vm.isNotHoline(_vm.intervention))?_c('div',{staticClass:"label center"},[_c('b',[_vm._v("ONU ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.onu.sn2),expression:"onu.sn2"}],attrs:{"id":"sn2","type":"text"},domProps:{"value":(_vm.onu.sn2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.onu, "sn2", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"video_3"}}),_vm._v(" "),_c('div',{staticClass:"button",attrs:{"id":"scan_3"},on:{"click":function($event){_vm.scan(3)}}},[_c('i',{staticClass:"fa fa-barcode",attrs:{"aria-hidden":"true"}}),_vm._v(" Scan\n        ")]),_vm._v(" "),_c('div',{staticClass:"button hide",attrs:{"id":"closescan_3"},on:{"click":function($event){_vm.CloseScan(3)}}},[_c('i',{staticClass:"fa fa-barcode",attrs:{"aria-hidden":"true"}}),_vm._v(" Stop scan\n        ")]),_vm._v(" "),(_vm.isNotHoline(_vm.intervention))?_c('div',{staticClass:"label center"},[_c('b',[_vm._v("SFP ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.onu.sn3),expression:"onu.sn3"}],attrs:{"id":"sn3","type":"text"},domProps:{"value":(_vm.onu.sn3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.onu, "sn3", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"video_4"}}),_vm._v(" "),_c('div',{staticClass:"button",attrs:{"id":"scan_4"},on:{"click":function($event){_vm.scan(4)}}},[_c('i',{staticClass:"fa fa-barcode",attrs:{"aria-hidden":"true"}}),_vm._v(" Scan\n        ")]),_vm._v(" "),_c('div',{staticClass:"button hide",attrs:{"id":"closescan_4"},on:{"click":function($event){_vm.CloseScan(4)}}},[_c('i',{staticClass:"fa fa-barcode",attrs:{"aria-hidden":"true"}}),_vm._v(" Stop scan\n        ")]),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":_vm.pushOnu}},[_c('i',{staticClass:"fa fa-paper-plane-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Déclarer\n        ")]),_vm._v(" "),_c('div',{staticClass:"viewport hide",attrs:{"id":"interactive"}},[_c('video',{attrs:{"autoplay":"true","preload":"auto","src":""}})])]):_c('div',{staticClass:"content"},[_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"}),_vm._v(" "),_c('div',{staticClass:"shimmer shimmer-label"})])]):_vm._e(),_vm._v(" "),(_vm.intervention.dateDebut && !_vm.intervention.dateFin && _vm.auditinfra)?_c('div'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ygFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debrief"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.upload)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"label"},[_c('i',{staticClass:"fa fa-cog fa-spin fa-3x fa-fw"}),_vm._v(" "),_c('br'),_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"header-intervention"},[_c('div',{staticClass:"header-info"}),_vm._v(" "),_c('div',{staticClass:"button-content"},[(_vm.photo)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.back()}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}}),_vm._v(" Annuler\n      ")]):_vm._e(),_vm._v(" "),(_vm.photo)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.startDebrief()}}},[_c('i',{staticClass:"fa fa-pencil-square-o"}),_vm._v(" Debrief\n      ")]):_vm._e(),_vm._v(" "),(_vm.debrief_started)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.backPhoto()}}},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Retour\n      ")]):_vm._e(),_vm._v(" "),(_vm.debrief_started)?_c('div',{staticClass:"button",on:{"click":_vm.uploadPicture}},[_c('i',{staticClass:"fa fa-paper-plane",attrs:{"aria-hidden":"true"}}),_vm._v(" Envoyer\n      ")]):_vm._e()])]),_vm._v(" "),_c('b-container',{class:_vm.wrapper_class},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.photo),expression:"photo"}]},[_vm._l((_vm.types_photo),function(file,index){return _c('div',{key:index,staticClass:"picture"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(file.description))]),_vm._v(" "),(file.image)?_c('img',{staticClass:"preview",attrs:{"src":file.image,"alt":""}}):_c('div',{staticClass:"picture-placeholder"},[_vm._v("Photo manquante")]),_vm._v(" "),_c('div',{staticClass:"options"},[_c('div',{staticClass:"rename",on:{"click":function($event){_vm.setPicture(file)}}},[_vm._v(_vm._s(file.image ? 'Modifier' : 'Ajouter'))])])])}),_vm._v(" "),_vm._l((_vm.files),function(file,index){return _c('div',{key:index,staticClass:"picture"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(file.description))]),_vm._v(" "),_c('img',{staticClass:"preview",attrs:{"src":file.image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"options"},[_c('div',{staticClass:"rename",on:{"click":function($event){_vm.rename(file)}}},[_vm._v("Renommer")]),_vm._v(" "),_c('div',{staticClass:"delete",on:{"click":function($event){_vm.deleteFile(file)}}},[_vm._v("Supprimer")])])])}),_vm._v(" "),_c('div',{staticClass:"buttonPhoto",on:{"click":function($event){_vm.setPicture()}}},[_c('i',{staticClass:"fa fa-camera",attrs:{"aria-hidden":"true"}}),_vm._v(" Ajouter des photos\n      ")]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFileChange}})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.photo),expression:"!photo"}],staticClass:"content-arbre"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zQ9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditPM_vue__ = __webpack_require__("PuG6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b197c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditPM_vue__ = __webpack_require__("pqyM");
function injectStyle (ssrContext) {
  __webpack_require__("vWbg")
  __webpack_require__("FzH4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24b197c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditPM_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b197c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditPM_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.77daa9ff9005471cdc3a.js